export const categories = [
  {
    id: 113,
    img: require("./assets/images/clew.webp"),
    title: "CLEW",
    color: "#90EE90",
    desc: "Raznovrsni mentolni i voćni profili za sve ljubitelje čistog i dugotrajnog osveženja.",
    descEN:
      "Diverse mint and fruit profiles for all fans of clean, long-lasting refreshment.",
    meta_description:
      "CLEW nikotinske vrećice kombinuju mentol i voćne note za vrhunsko osveženje i čist ukus. Idealno za svakodnevnu upotrebu.",
    keywords:
      "clew snus, clew Srbija, clew mentol, clew voćni ukusi, nikotinske vrećice",
    seoContent:
      "CLEW nikotinske kesice kombinuju mentolne i voćne arome u jednom proizvodu, pružajući svež i dugotrajan ukus. Dostupne su u više jačina nikotina, pa lako možete pronaći varijantu koja vam najviše odgovara.",
    faq: [
      { q: "Koje ukuse CLEW nudi?", a: "CLEW u ponudi ima nekoliko ukusa: Wintergreen, Blueberry, Watermelon, Spearmint, Menthol i Cool Mint." },
      { q: "Koja je jačina nikotina kod CLEW proizvoda?", a: "CLEW nikotinske kesice dolaze u varijantama od 10mg i 20mg, u zavisnosti od ukusa, pa svako može izabrati jačinu koja mu odgovara." },
      { q: "Kako se koristi CLEW nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za CLEW proizvode?", a: "Da, svi CLEW proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 114,
    img: require("./assets/images/stng.webp"),
    title: "STNG",
    color: "#D32F2F",
    desc: "Jaki i energični ukusi – od kole do bobičastih i voćnih eksplozija za maksimalno osveženje.",
    descEN:
      "Strong and energetic flavors – from cola to berry and fruit explosions for maximum refreshment.",
    meta_description:
      "STNG nikotinske vrećice nude intenzivne ukuse kole, bobičastog voća i bubble gum varijanti za one koji traže snažan doživljaj.",
    keywords:
      "stng snus, stng Srbija, stng cola cherry, stng berry seltzer, stng bubble gum",
    seoContent:
      "STNG se izdvaja intenzivnim ukusima poput kole, bobičastog voća i bubble gum-a, namenjenim korisnicima koji traže nešto drugačije od klasičnog mentola. Kesice su tanke i diskretne, pogodne za nošenje tokom celog dana.",
    faq: [
      { q: "Koje ukuse STNG nudi?", a: "STNG u ponudi ima nekoliko ukusa: Cola Cherry MAX, Berry Seltzer MAX i Bubble MAX." },
      { q: "Koja je jačina nikotina kod STNG proizvoda?", a: "STNG proizvodi spadaju u jače (MAX) varijante, namenjene korisnicima koji traže izraženiji efekat nikotina." },
      { q: "Kako se koristi STNG nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za STNG proizvode?", a: "Da, svi STNG proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 1,
    img: require("./assets/images/category1.webp"),
    title: "VELO", //feders zelena - crvena,  3-crvena(svetlo plava/crna), crvena, siberia - svetlo plava, iceberg - narandzasta, grant-zlatna
    color: "#f42d3d",
    desc: "Pružaju jedinstveno iskustvo uživanja u snusu.",
    descEN: "Provides a unique snus enjoyment experience.",
    meta_description:
      "VELO snus – veliki izbor ukusa i jačina, na stanju. Naručite online po povoljnoj ceni uz brzu dostavu širom Srbije.",
    keywords: "velo snus, velo snus cena",
    seoContent:
      "VELO je jedan od vodećih svetskih brendova nikotinskih kesica (snus bez duvana), poznat po čistom ukusu i preciznoj jačini nikotina. U ponudi imamo širok izbor VELO ukusa i jačina – od blagih do ekstra jakih (Mighty Peppermint, X Freeze Ultra, Ice Cool Slim i drugi) – tako da svako može pronaći proizvod koji odgovara njegovom iskustvu. Svi VELO proizvodi su bez duvana, bez mrlja na zubima i pogodni za diskretnu upotrebu tokom dana. Poručite VELO snus online na Snus Srbija uz brzu dostavu i povoljne cene.",
    faq: [
      {
        q: "Koje ukuse VELO nudi?",
        a: "VELO ima širok asortiman ukusa, uključujući Mighty Peppermint, X Freeze Ultra i Ice Cool Slim, u regularnim i ekstra jakim (MAX, X-Strong) varijantama.",
      },
      {
        q: "Koja je jačina nikotina kod VELO proizvoda?",
        a: "VELO nudi proizvode od blagih do ekstra jakih (MAX, X-Strong) varijanti, tako da svako može pronaći jačinu koja mu odgovara.",
      },
      {
        q: "Da li VELO sadrži duvan?",
        a: "Ne, VELO nikotinske kesice su potpuno bez duvana.",
      },
      {
        q: "Kako se koristi VELO nikotinska kesica?",
        a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca.",
      },
      {
        q: "Da li imate brzu dostavu za VELO proizvode?",
        a: "Da, svi VELO proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice.",
      },
    ],
  },
  {
    id: 2,
    img: require("./assets/images/category3.webp"),
    title: "PABLO",
    color: "#f91f2b",
    desc: "brend koji se fokusira na visokokvalitetni i luksuzni snus, sa dodatkom prirodnih aroma i ekstrakata.  ",
    descEN:
      "A brand that focuses on high-quality and luxurious snus with added natural flavors and extracts.",
    meta_description:
      "Otkrijte jedinstvenu kategoriju Pablo nikotinskih proizvoda, koja nudi visoko kvalitetne proizvode sa prirodno uzgojenim duvanom i različitim aromama. Otkrijte pablo snus razlicitih mg jacina ",
    keywords: "pablo snus, pablo snus mg",
    seoContent:
      "PABLO je prepoznatljiv po snažnom sadržaju nikotina i prirodnim aromama, namenjen iskusnijim korisnicima koji traže izraženiji efekat. Dostupan je u nekoliko jačina, od izrazito jakih do ekstremnih varijanti.",
    faq: [
      { q: "Koje ukuse PABLO nudi?", a: "PABLO u ponudi ima nekoliko ukusa: Ice Cold, Frosted Mint i nekoliko Exclusive varijanti (Banana Ice, Mango Ice, Grape Ice, Kiwi, Passion Fruit)." },
      { q: "Koja je jačina nikotina kod PABLO proizvoda?", a: "PABLO nudi proizvode različitih jačina nikotina, od standardnih do izrazito jakih varijanti za iskusnije korisnike." },
      { q: "Da li PABLO sadrži duvan?", a: "Da, PABLO proizvodi sadrže prirodno uzgojeni duvan u kombinaciji sa različitim aromama." },
      { q: "Kako se koristi PABLO nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za PABLO proizvode?", a: "Da, svi PABLO proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 3,
    img: require("./assets/images/category2.webp"),
    title: "GARANT",
    color: "#f4d35e",
    desc: "brend koji nudi tradicionalni snus u različitim ukusima",
    descEN: "A brand that offers traditional snus in various flavors.",
    meta_description:
      " Garant snus nikotinski proizvodi proizvodi pružaju diskretan i jednostavan način za uživanje u nikotinu bez dima i neprijatnih mirisa. Najbolja garant cena proizvoda u regionu.",
    keywords: "garant snus, garant cena",
    seoContent:
      "GARANT nudi tradicionalni snus u raznovrsnim ukusima po pristupačnim cenama, idealan za svakodnevnu upotrebu. Ponuda obuhvata i blage i jače varijante, prilagođene različitim preferencama korisnika.",
    faq: [
      { q: "Koje ukuse GARANT nudi?", a: "GARANT u ponudi ima nekoliko ukusa: Extreme Edition, Ice Cool i više Extreme voćnih varijanti (Mango Lime, Ice Peach, Ice Blueberry, Raspberry, Cherry, Grape)." },
      { q: "Koja je jačina nikotina kod GARANT proizvoda?", a: "GARANT nudi regularne i Extreme Edition varijante sa jačim sadržajem nikotina za one koji traže izraženiji doživljaj." },
      { q: "Kako se koristi GARANT nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za GARANT proizvode?", a: "Da, svi GARANT proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  // {
  //   id: 4,
  //   img: require("./assets/images/lyftCategory.webp"),
  //   title: "LYFT",
  //   color: "#f91f2b",
  //   desc: "brend koji nudi nikotinske proizvode bez duvana, sa ukusom i bez mirisa",
  //   descEN:
  //     "A brand that offers tobacco-free nicotine products with taste and no scent.",
  //   meta_description:
  //     "LYFT snus nikotinski proizvodi pružaju diskretan i jednostavan način za uživanje u nikotinu bez dima i neprijatnih mirisa. Najbolja cena LYFT proizvoda u regionu.",
  //   keywords: "LYFT snus, cena LYFT, nikotinski proizvodi bez duvana",
  // },
  {
    id: 5,
    img: require("./assets/images/fedrsCategory.webp"),
    title: "FEDRS",
    color: "#0d6129",
    desc: "za diskretne korisnike",
    descEN: "For discreet users.",
    meta_description:
      "FEDRS snus nikotinski proizvodi su idealan izbor za sve ljubitelje čistog i snažnog osećaja nikotina. Svojom raznovrsnom ponudom proizvoda FEDRS odgovara na potrebe svih korisnika. Najbolje cene FEDRS proizvoda u regionu.",
    keywords: "FEDRS snus, FEDRS cena",
    seoContent:
      "FEDRS je namenjen korisnicima koji traže čist i snažan osećaj nikotina uz diskretno pakovanje. Asortiman uključuje mentolne i mešane ukuse u više nivoa jačine.",
    faq: [
      { q: "Koje ukuse FEDRS nudi?", a: "FEDRS u ponudi ima nekoliko ukusa: Ice Cool Mint Hard Slim, Ice Cool Hard Double Mint i Maradona." },
      { q: "Koja je jačina nikotina kod FEDRS proizvoda?", a: "FEDRS nudi proizvode različite jačine, uključujući Extra Strong varijante za iskusnije korisnike." },
      { q: "Kako se koristi FEDRS nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za FEDRS proizvode?", a: "Da, svi FEDRS proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 6,
    img: require("./assets/images/icebergCategory.webp"),
    title: "ICEBERG",
    color: "#f5841f",
    desc: "brend koji nudi raznolikost ukusa i jaku snagu nikotina",
    descEN:
      "A brand that offers a variety of flavors and strong nicotine power.",
    meta_description:
      "ICEBERG snus nikotinski proizvodi pružaju jedinstvene ukuse i snažan doživljaj nikotina. Odaberite svoj omiljeni ukus i uživajte u trenutku svežine i podsticaja. Najbolja cena za ICEBERG proizvode u regionu.",
    keywords: "iceberg snus, iceberg cena, snus srbija",
    seoContent: [
      "ICEBERG nikotinske kesice poznate su po izuzetno jakom hladećem efektu i intenzivnim ukusima, namenjenim korisnicima koji traže snažan i osvežavajući doživljaj. Asortiman je jedan od najraznovrsnijih na tržištu – od klasičnih mentol i mint varijanti (Menthol, Frosty Mint Extreme) i voćnih kombinacija (Kiwi Strawberry, Watermelon Mint, Dragon Fruit, Grape, Guava Lime), do neobičnih ukusa poput Cola, Double Apple, Bubblegum i Crazy Mix. Bez duvana, dima i pepela, ICEBERG proizvodi su praktični za svakodnevnu, diskretnu upotrebu.",
      "Jačina nikotina razlikuje se od proizvoda do proizvoda – pored regularnih varijanti, ICEBERG nudi i \"Extreme\"/\"Extra Strong\" verzije namenjene iskusnijim korisnicima koji traže izraženiji efekat, dok su blaže varijante pogodnije za one koji tek počinju. Svaka kesica se jednostavno postavlja između usne i desni, bez potrebe za pljuvanjem ili paljenjem. Pogledajte celu ICEBERG ponudu na Snus Srbija i naručite uz brzu dostavu.",
    ],
    relatedLinks: [
      { label: "Iceberg Emerald", to: "/iceberg-emerald" },
      { label: "Iceberg Menthol", to: "/iceberg-menthol" },
    ],
    faq: [
      {
        q: "Koja je razlika između regularnih i Extreme/Extra Strong ICEBERG varijanti?",
        a: "Extreme i Extra Strong varijante imaju izraženiji, snažniji efekat nikotina i namenjene su iskusnijim korisnicima, dok su regularne varijante blaže i pogodnije za svakodnevnu upotrebu ili za one koji tek počinju.",
      },
      {
        q: "Da li ICEBERG sadrži duvan?",
        a: "Ne, ICEBERG nikotinske kesice su potpuno bez duvana, dima i pepela.",
      },
      {
        q: "Kako se koristi ICEBERG nikotinska kesica?",
        a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca.",
      },
      {
        q: "Da li imate brzu dostavu za ICEBERG proizvode?",
        a: "Da, svi ICEBERG proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice.",
      },
    ],
  },
  // {
  //   id: 7,
  //   img: require("./assets/images/siberiaCategory.webp"),
  //   title: "SIBERIA",
  //   color: "#26cad3",
  //   desc: "savršeni za iskusne korisnike",
  //   descEN: "Perfect for experienced users.",
  //   meta_description:
  //     "Isprobajte intenzivan i dugotrajni efekat hladnoće uz SIBERIA nikotinske snusove. Otkrijte širok izbor različitih aroma i jačina u našoj ponudi. Bez dima, bez pepela - samo čisti užitak uz SIBERIA",
  //   keywords: "siberia snus, siberia cena, snus srbija",
  // },
  // {
  //   id: 8,
  //   img: require("./assets/images/kurwaCategory.webp"),
  //   title: "KURWA",
  //   color: "#ffd100",
  //   desc: "za avanturiste i istraživače",
  //   descEN: "For adventurers and explorers.",
  //   meta_description:
  //     "Otkrijte intenzivan i dugotrajni efekat hladnoće sa KURWA nikotinskim snusovima. Ponosno predstavljamo raznovrsne arome i jačine koje će zadovoljiti i najiskusnije korisnike. Uživajte u čistom zadovoljstvu uz KURWA, bez dima i pepela.",
  //   keywords: "kurwa snus, kurwa cena, snus Srbija",
  //},
  {
    id: 9,
    img: require("./assets/images/killaCategory.webp"),
    title: "KILLA",
    color: "#ff3838",
    desc: "za ljubitelje mentol arome",
    descEN: "For menthol flavor enthusiasts.",
    meta_description:
      "Iskusite intenzivnu mentol eksploziju sa Killa nikotinskim snusovima. Snažan i dugotrajan efekat hladnoće pruža poseban doživljaj. Killa snusovi nude različite jačine i arome, prilagođene vašem ukusu.",
    keywords: "killa snus, mentol",
    seoContent:
      "KILLA se fokusira na intenzivne mentol ukuse sa jakim i dugotrajnim hladećim efektom. Dostupan je u više jačina, pogodan i za iskusnije korisnike koji traže snažan doživljaj.",
    faq: [
      { q: "Koji ukus KILLA nudi?", a: "KILLA se fokusira na Cold Mint ukus, sa intenzivnim i dugotrajnim hladećim efektom." },
      { q: "Koja je jačina nikotina kod KILLA proizvoda?", a: "KILLA proizvodi su namenjeni korisnicima koji traže snažniji, izraženiji ukus mentola." },
      { q: "Kako se koristi KILLA nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za KILLA proizvode?", a: "Da, svi KILLA proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 10,
    img: require("./assets/images/rabbitCategory.webp"),
    title: "RABBIT",
    color: "#45aaf2",
    desc: "za ljubitelje voćnih aroma",
    descEN: "For fruit flavor enthusiasts.",
    meta_description:
      "Istražite širok spektar voćnih aroma sa Rabbit nikotinskim snusovima. Uživajte u jedinstvenim i osvežavajućim ukusima koji će probuditi vaša čula. Dostupni u različitim jačinama, Rabbit pruža uživanje bez dima i pepela.",
    keywords: "rabbit snus, voćne arome, Rabbit Srbija",
    seoContent:
      "RABBIT donosi širok izbor voćnih aroma za korisnike koji žele nešto osvežavajuće i drugačije od klasičnog mentola. Proizvodi su dostupni u različitim jačinama nikotina.",
    faq: [
      { q: "Koje ukuse RABBIT nudi?", a: "RABBIT u ponudi ima nekoliko ukusa: Blue Ice, Cola i Pepper Mint Extreme." },
      { q: "Koja je jačina nikotina kod RABBIT proizvoda?", a: "RABBIT nudi proizvode različite jačine, od standardnih do Extreme varijanti." },
      { q: "Kako se koristi RABBIT nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za RABBIT proizvode?", a: "Da, svi RABBIT proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 11,
    img: require("./assets/images/thunderCategory.webp"),
    title: "THUNDER",
    color: "#E51D3B",
    desc: "za ljubitelje jakih aroma",
    descEN: "For strong flavor enthusiasts.",
    meta_description:
      "Iskusite snagu jakih aroma sa Thunder nikotinskim snusovima. Uz raznolike i intenzivne ukuse, Thunder pruža snažno iskustvo korisnicima. Dostupni u različitim jakostima, Thunder je za one koji traže snažan udarac.",
    keywords: "thunder snus, jake arome, Thunder Srbija",
    seoContent:
      "THUNDER je namenjen ljubiteljima jakih i izraženih aroma, sa fokusom na snažan nikotinski udarac. Ponuda uključuje nekoliko varijanti jačine za različite nivoe iskustva.",
    faq: [
      { q: "Koje ukuse THUNDER nudi?", a: "THUNDER u ponudi ima nekoliko ukusa: Dark Forest i Deep Freeze." },
      { q: "Koja je jačina nikotina kod THUNDER proizvoda?", a: "THUNDER proizvodi su namenjeni ljubiteljima jakih aroma sa snažnim nikotinskim udarcem." },
      { q: "Kako se koristi THUNDER nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za THUNDER proizvode?", a: "Da, svi THUNDER proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  // {
  //   id: 12,
  //   img: require("./assets/images/voltCategory.webp"),
  //   title: "VOLT",
  //   color: "#1f1f1",
  //   desc: "za ljubitelje neutralnih aroma",
  //   descEN: "For neutral flavor enthusiasts.",
  //   meta_description:
  //     "Otkrijte neutralne arome sa Volt nikotinskim kesicama. Blagi i uravnoteženi ukusi pružaju diskretno iskustvo. Sa različitim opcijama, Volt nudi suptilnu promenu bez previše jakih nota.",
  //   keywords: "volt snus,  Volt Srbija, nikotinskim kesicama",
  // },
  {
    id: 13, // Pretpostavljeni ID za kategoriju ZYN
    img: require("./assets/images/images/zynCategory.png"),
    title: "ZYN",
    color: "#45aaf2", // Pretpostavljena boja za ZYN kategoriju
    desc: "za ljubitelje osvežavajućih i intenzivnih ukusa",
    descEN: "For enthusiasts of refreshing and intense flavors.",
    meta_description:
      "ZYN nikotinske kesice – švedski kvalitet, na stanju. Naručite online po povoljnoj ceni uz brzu dostavu širom Srbije.",
    keywords: "ZYN snus, ZYN Srbija, nikotinske vrećice",
    seoContent:
      "ZYN je švedski brend nikotinskih kesica koji se izdvaja diskretnim, tankim formatom i čistim, dugotrajnim ukusom bez duvana. Idealan je za korisnike koji žele precizno kontrolisanu jačinu nikotina i suptilnu upotrebu bez dima i mirisa. U ponudi imamo različite ZYN ukuse i jačine, prilagođene i početnicima i iskusnijim korisnicima. Naručite ZYN nikotinske kesice online na Snus Srbija uz brzu dostavu i sigurnu kupovinu.",
    faq: [
      {
        q: "Koje ukuse ZYN nudi?",
        a: "ZYN nudi ukuse poput Cool Mint Slim Extreme Strong, Spearmint Slim Strong i Fresh Mint Slim, u tankom, diskretnom formatu.",
      },
      {
        q: "Koja je jačina nikotina kod ZYN proizvoda?",
        a: "ZYN dolazi u više jačina, od blažih do Extreme Strong varijanti za iskusnije korisnike.",
      },
      {
        q: "Da li ZYN sadrži duvan?",
        a: "Ne, ZYN nikotinske kesice su potpuno bez duvana.",
      },
      {
        q: "Kako se koristi ZYN nikotinska kesica?",
        a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca.",
      },
      {
        q: "Da li imate brzu dostavu za ZYN proizvode?",
        a: "Da, svi ZYN proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice.",
      },
    ],
  },
  {
    id: 14, // Pretpostavljeni ID za kategoriju CUBA
    img: require("./assets/images/images/cubaCategory.webp"),
    title: "CUBA",
    color: "#000",
    desc: "Za ljubitelje bogatih i voćnih ukusa.",
    descEN: "For fans of rich and fruity flavors.",
    meta_description:
      "Uživajte u CUBA nikotinskim vrećicama koje donose bogate i voćne ukuse sa intenzivnim doživljajem. Savršene za one koji traže egzotične i dugotrajne senzacije.",
    keywords: "CUBA snus, CUBA Srbija, nikotinske vrećice",
    seoContent:
      "CUBA se izdvaja bogatim, voćnim i pomalo egzotičnim ukusima, namenjenim korisnicima koji traže nešto drugačije od klasičnih varijanti. Dostupna je u više jačina nikotina.",
    faq: [
      { q: "Koje ukuse CUBA nudi?", a: "CUBA je poznata po prepoznatljivoj \"Black\" liniji ukusa: Black Watermelon, Black Cola, Black Cherry Slim, Black Peach, Black Pineapple, Black Currant, Black Blueberry i drugi." },
      { q: "Koja je jačina nikotina kod CUBA proizvoda?", a: "CUBA nudi proizvode različitih jačina, prilagođene i početnicima i iskusnijim korisnicima." },
      { q: "Kako se koristi CUBA nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za CUBA proizvode?", a: "Da, svi CUBA proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 15,
    img: require("./assets/images/images/white-fox-category.png"),
    title: "WHITE FOX",
    color: "#FFFFFF",
    desc: "Za ljubitelje čistih, osvežavajućih i mentolnih ukusa.",
    descEN: "For enthusiasts of clean, refreshing, and minty flavors.",
    meta_description:
      "Otkrijte WHITE FOX nikotinske vrećice sa čistim, osvežavajućim ukusima i jakim nikotinskim udarcima. Dizajnirane za one koji traže svežinu i intenzivnost.",
    keywords: "WHITE FOX snus, WHITE FOX Srbija, nikotinske vrećice",
    seoContent:
      "WHITE FOX je prepoznatljiv po čistim, osvežavajućim mentol ukusima i jakom nikotinskom udarcu, u elegantnom i diskretnom pakovanju. Ponuda obuhvata više varijanti — od klasičnih do ekstremno jakih — za korisnike svih nivoa iskustva.",
    faq: [
      { q: "Koje ukuse WHITE FOX nudi?", a: "WHITE FOX u ponudi ima nekoliko varijanti: All White Portion, Black Edition, Full Charge i Peppered Mint." },
      { q: "Koja je jačina nikotina kod WHITE FOX proizvoda?", a: "WHITE FOX ponuda obuhvata više varijanti jačine – od klasičnih do ekstremno jakih." },
      { q: "Kako se koristi WHITE FOX nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za WHITE FOX proizvode?", a: "Da, svi WHITE FOX proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 47,
    img: require("./assets/images/camoCategory.jpeg"),
    title: "CAMO",
    color: "#A4C639",
    desc: "Za one koji traže osvežavajuće ukuse i balansiranu jačinu.",
    descEN: "For those seeking refreshing flavors and balanced strength.",
    meta_description:
      "Otkrijte CAMO nikotinske vrećice sa osvežavajućim i inovativnim ukusima. Idealne za svakodnevnu upotrebu i ljubitelje diskretnog uživanja.",
    keywords: "CAMO snus, CAMO Srbija, nikotinske vrećice",
    seoContent:
      "CAMO nudi osvežavajuće i inovativne ukuse balansirane jačine, pogodne za svakodnevnu upotrebu. Diskretno pakovanje čini ga praktičnim izborom tokom celog dana.",
    faq: [
      { q: "Koje ukuse CAMO nudi?", a: "CAMO u ponudi ima nekoliko ukusa: Ice Cold Mint, Wild Mint, Peppermint i Spicy Citrus." },
      { q: "Koja je jačina nikotina kod CAMO proizvoda?", a: "CAMO nudi proizvode balansirane, umerene jačine, pogodne za svakodnevnu upotrebu." },
      { q: "Kako se koristi CAMO nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za CAMO proizvode?", a: "Da, svi CAMO proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  {
    id: 48,
    img: require("./assets/images/77Category.webp"),
    title: "77",
    color: "#FF5252",
    desc: "Raznovrsni ukusi za svakodnevno uživanje u nikotinskim vrećicama.",
    descEN: "A variety of flavors for everyday enjoyment of nicotine pouches.",
    meta_description:
      "Otkrijte 77 nikotinske vrećice sa širokim spektrom ukusa. Idealne za one koji traže kvalitet i raznovrsnost u svakom trenutku.",
    keywords: "77 snus, 77 Srbija, nikotinske vrećice",
    seoContent:
      "Brend 77 nudi raznovrsne ukuse za svakodnevno uživanje, sa fokusom na kvalitet i dosledno iskustvo. Pogodan je za korisnike koji žele proveren proizvod bez iznenađenja.",
    faq: [
      { q: "Koje ukuse 77 nudi?", a: "77 u ponudi ima nekoliko ukusa: Tropical Mint Slim Medium, Cola Cherry Medium, Cola Vanilla Medium i Watermelon Ice Medium." },
      { q: "Koja je jačina nikotina kod 77 proizvoda?", a: "77 linija je uglavnom umerene (Medium) jačine, pogodna za korisnike koji ne traže ekstremno jake proizvode." },
      { q: "Kako se koristi 77 nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za 77 proizvode?", a: "Da, svi 77 proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
  // {
  //   id: 80,
  //   img: require("./assets/images/XQSCategory.webp"),
  //   title: "XQS",
  //   color: "#00BFFF",
  //   desc: "Inovativni ukusi i moderni formati za osvežavajuće iskustvo nikotinskih vrećica.",
  //   descEN:
  //     "Innovative flavors and modern formats for a refreshing nicotine pouch experience.",
  //   meta_description:
  //     "XQS nikotinske vrećice nude bogat izbor ukusa – od voćnih do mentol i gaziranih. Savršeno za sve koji žele balans između snage i arome.",
  //   keywords:
  //     "xqs snus, xqs Srbija, xqs nikotinske vrećice, snus online prodaja",
  // },
  {
    id: 146,
    img: require("./assets/images/rush.webp"),
    title: "RUSH",
    color: "#ADD8E6",
    desc: "Snažni mentol ukusi i moderan dizajn za osvežavajući i intenzivan doživljaj.",
    descEN:
      "Powerful menthol flavors and modern design for a refreshing and intense experience.",
    meta_description:
      "RUSH nikotinske vrećice nude snažne mentol kombinacije u slim formatu, idealne za korisnike koji traže jak i osvežavajući efekat.",
    keywords:
      "rush snus, rush Srbija, rush nikotinske vrećice, mentol snus, snus online prodaja",
    seoContent:
      "RUSH kombinuje snažne mentol ukuse sa modernim, tankim dizajnom kesica za osvežavajući i intenzivan doživljaj. Pogodan je za korisnike koji traže jak efekat u praktičnom slim formatu.",
    faq: [
      { q: "Koje ukuse RUSH nudi?", a: "RUSH u ponudi ima nekoliko ukusa: Ice Cool, Green Mint i Boost Mint Extreme." },
      { q: "Koja je jačina nikotina kod RUSH proizvoda?", a: "RUSH nudi proizvode različite jačine, uključujući Extreme varijante za jači efekat." },
      { q: "Kako se koristi RUSH nikotinska kesica?", a: "Kesica se jednostavno postavlja između gornje usne i desni na 20-40 minuta – nema potrebe za paljenjem, dimom ili pljuvanjem, a nakon upotrebe se jednostavno baca." },
      { q: "Da li imate brzu dostavu za RUSH proizvode?", a: "Da, svi RUSH proizvodi dostupni su uz brzu dostavu širom Srbije preko Snus Srbija online prodavnice." },
    ],
  },
];

export const seo_products = [
  {
    id: 1,
    title: "Mighty Peppermint",
    category: "VELO",
    meta_description:
      "VELO Mighty Peppermint – osvežavajući ukus nane, na stanju odmah. Naručite po povoljnoj ceni uz brzu dostavu na Snus Srbija.",
    cover_img: require(`./assets/images/products/velo-mighty-peppermint.webp`),
    keywords: "velo mighty peppermint cena, velo snus prodaja, brza dostava",
  },
  {
    id: 2,
    title: "X Freeze Ultra",
    category: "VELO",
    meta_description:
      "Uživajte u bezvremenskom ukusu mente uz VELO X Freeze Ultra nikotinske jastučiće. Pronađite ih na našoj stranici snus prodaja i uživajte u besplatnoj dostavi za sve narudžbe!",
    cover_img: require("./assets/images/products/velo-x-freeze-ultra.webp"),
    keywords: "snus prodaja",
  },
  {
    id: 3,
    title: "Ice Cool Slim",
    category: "VELO",
    meta_description:
      "Upoznajte Velo Crispy Peppermint - vaš novi saveznik u održavanju svežeg daha! Ovaj proizvod kombinuje živahni ukus nane sa jedinstvenom hrskavom teksturkom, pružajući trenutnu eksploziju svežine.",
    cover_img: require("./assets/images/products/velo-ice-cool-slim.webp"),
    keywords: "snus prodaja",
  },
  {
    id: 4,
    title: "Ice Cold",
    category: "PABLO",
    meta_description:
      "PABLO Ice Cold nikotinske kesice – hladan ukus i visok nikotin, na stanju. Povoljna cena i brza dostava, poručite odmah.",
    cover_img: require("./assets/images/products/pablo-ice-cold.webp"),
    keywords: "pablo ice cold cena, pablo snus prodaja, brza dostava",
  },
  {
    id: 5,
    title: "Extreme Edition",
    category: "GARANT",
    meta_description:
      "Isprobajte našu novu Extreme Edition nikotinsku kesicu sa visokim sadržajem nikotina i intenzivnim ukusom. Ne preporučuje se početnicima. Kupite odmah na našoj stranici - snus prodaja",
    cover_img: require("./assets/images/products/grant-extreme-edition.webp"),
    keywords: "snus prodaja",
  },
  {
    id: 6,
    title: "Mighty Peppermint MAX",
    category: "VELO",
    meta_description:
      "Iskusite vrhunsku svežinu i jaku nikotinsku snagu sa VELO Mighty Peppermint MAX. Ovaj inovativni nikotinski proizvod nudi intenzivan mentolasti ukus bez dima i pepela, idealan za korišćenje u svakoj situaciji. Pređite na čistiju alternativu pušenju sa VELO i uživajte u diskretnom, praktičnom načinu zadovoljenja vaših nikotinskih potreba. Savršeno za korisnike koji traže snažno iskustvo bez kompromisa.",
    cover_img: require("./assets/images/products/velo-mighty-peppermint-max.webp"),
    keywords: "snus prodaja",
  },
  {
    id: 7,
    title: "Cool Storm Slim X-Strong",
    category: "VELO",
    meta_description:
      "Energizirajte se uz Velo Cool Storm Slim X-Strong nikotinske kesice sa visokim sadržajem nikotina. Osetite snažan i dugotrajan ukus mente koji će vas osvežiti bez duvana. Kupite odmah na našoj stranici - snus prodaja",
    cover_img: require("./assets/images/products/velo-cool-storm-slim-x-strong.webp"),
    keywords: "snus prodaja",
  },
  {
    id: 8,
    title: "Spicy Pineapple Slim Strong",
    category: "VELO",
    meta_description:
      "Probudite svoja čula uz Velo Spicy Pineapple Slim Strong nikotinske jastučiće sa snažnim ukusom ananasa i blagim pikantnim začinima. Bez duvana i neugodnih mirisa. Kupite ih odmah na našoj stranici - snus prodaja.",
    cover_img: require("./assets/images/products/velo-spicy-pineapple-slim-strong.webp"),
    keywords: "snus prodaja",
  },
  {
    id: 9,
    title: "Blushy Berry",
    category: "VELO",
    meta_description:
      "VELO Blushy Berry nikotinske vrećice: Vaša dnevna doza zadovoljstva sa ukusom bobica. Bezdimno, diskretno, i spremno za uživanje u svakom trenutku.",
    cover_img: require("./assets/images/products/velo_blushy_berry.webp"),
    keywords: "snus prodaja",
  },
  {
    id: 10,
    title: "Mini Groovy Grape",
    category: "VELO",
    meta_description:
      "VELO Mini Groovy Grape nikotinske vrećice: Intenzivan ukus grožđa u diskretnom formatu. Savršeno za ljubitelje nikotina koji cene eleganciju i praktičnost.",
    cover_img: require("./assets/images/products/groovy_grape_mini.webp"),
    keywords: "nikotinske vrećice",
  },
  // novo
  {
    id: 11,
    title: "Ice Cool",
    category: "GARANT",
    meta_description:
      "GARANT Ice Cool nikotinske kesice – snažan mentol ukus, na stanju. Povoljna cena i brza dostava širom Srbije, poručite odmah.",
    cover_img: require("./assets/images/products/grant-ice-cool.webp"),
    keywords: "garant ice cool cena, garant snus prodaja, brza dostava",
  },
  {
    id: 12,
    title: "Mango Lime Extreme Edition",
    category: "GARANT",
    meta_description:
      "Isprobajte GARANT Mango Lime Extreme Edition nikotinski proizvod sa intenzivnim ukusom manga i limete. Uživajte u diskretnom i jednostavnom načinu konzumiranja nikotina bez duvana i neprijatnih mirisa. Kupite ih odmah na našoj stranici - snus prodaja.",
    cover_img: require("./assets/images/products/grant-mango-lime.webp"),
    keywords: "nikotinski proizvod, snus prodaja",
  },
  {
    id: 13,
    title: "Ice Peach Extreme Edition",
    category: "GARANT",
    meta_description:
      "Isprobajte GARANT Ice Peach Extreme Edition nikotinski proizvod sa osvežavajućim ukusom breskve i jakim osećajem nikotina. Narucite ih odmah na našoj snus online prodavnici.",
    cover_img: require("./assets/images/products/grant-ice-peach.webp"),
    keywords: "nikotinski proizvod, snus online",
  },
  {
    id: 14,
    title: "Ice Blueberry Extreme Edition",
    category: "GARANT",
    meta_description:
      "Isprobajte GARANT Ice Blueberry Extreme Edition nikotinski proizvod sa osvežavajućim ukusom borovnice i jakim osećajem nikotina. Snus na teritoriji cele Srbije.  Naručite ih odmah na našoj snus online prodavnici.",
    cover_img: require("./assets/images/products/grant-ice-blueberry.webp"),
    keywords: "snus online",
  },
  {
    id: 15,
    title: "Cool Air Slim Extra Strong",
    category: "LYFT",
    meta_description:
      "LYFT Cool Air Slim Extra Strong je inovativni proizvod koji pruža jak osvežavajući ukus mente i hladan osećaj",
    cover_img: require("./assets/images/products/lyft-cool-air-slim-extra-strong.webp"),
    keywords: "snus online, snus prodaja",
  },
  {
    id: 16,
    title: "Cool Air Slim ULTRA Strong",
    category: "LYFT",
    meta_description:
      "LYFT Cool Air Slim ULTRA Strong je najjači proizvod u Cool Air liniji, sa intenzivnim osvežavajućim ukusom mente i još jačim osećajem. Kupite ih odmah na našoj snus online prodavnici, snus prodaja.",
    cover_img: require("./assets/images/products/lyft-cool-air-slim-ultra-strong.webp"),
    keywords: "snus online, snus prodaja",
  },
  {
    id: 17,
    title: "Ice Cool Mint Hard Slim",
    category: "FEDRS",
    meta_description:
      "FEDRS Ice Cool Mint Hard Slim – snažna dupla menta, na stanju. Naručite po povoljnoj ceni uz brzu dostavu.",
    cover_img: require("./assets/images/products/fedrs-ice-cool-mint.webp"),
    keywords: "fedrs ice cool mint hard slim cena, fedrs snus prodaja, brza dostava",
  },
  {
    id: 18,
    title: "FEDRS Ice Cool Mint No.8 Extra Strong Slim",
    category: "FEDRS",
    meta_description:
      "Isprobajte FEDRS Ice Cool Mint No.8 Extra Strong Slim, nikotinski proizvod sa osvežavajućim ukusom mente i jakim osećajem nikotina. Bez duvana i sa diskretnim i jednostavnim načinom konzumiranja. Naručite ih odmah na našoj snus online prodavnici - snus prodaja.",
    cover_img: require("./assets/images/products/fedrs-ice-cool-mint-no8.webp"),
    keywords: "snus prodaja, nikotinski proizvod, snus online prodavnica",
  },
  {
    id: 19,
    title: "Black Slim Extreme",
    category: "ICEBERG",
    meta_description:
      "Isprobajte ICEBERG Black Slim Extreme, nikotinski proizvod sa jakim ukusom duvana i mentola. Neka vas preplavi osvežavajuća aroma i snažan osećaj nikotina. Kupite ga odmah na našoj online prodavnici snusa.",
    cover_img: require("./assets/images/products/iceberg-black-slim-extreme.webp"),
    keywords: "snus",
  },
  {
    id: 20,
    title: "Strawberry Banana Gum Slim Extreme",
    category: "ICEBERG",
    meta_description:
      "Isprobajte ICEBERG Strawberry Banana Gum Slim Extreme - inovativni nikotinski proizvod sa ukusom slatke jagode, banane i žvakaće gume. ",
    cover_img: require("./assets/images/products/iceberg-strawberry-banana-gum.webp"),
    keywords: "",
  },
  {
    id: 21,
    title: "Watermelon Mint Gum Slim Extreme",
    category: "ICEBERG",
    meta_description:
      "Isprobajte ICEBERG Watermelon Mint Gum Slim Extreme nikotinski proizvod sa ukusom lubenice i mente. Poručite odmah na našoj snus online prodavnici - snus prodaja.",
    cover_img: require("./assets/images/products/iceberg-watermelon-mint-gum.webp"),
    keywords: "nikotinski proizvod, snus prodaja",
  },
  {
    id: 22,
    title: "Raspberry Gum Slim Extreme",
    category: "ICEBERG",
    meta_description:
      "Isprobajte ICEBERG Raspberry Gum Slim Extreme - najnoviji dodatak asortimanu sa ukusom sveže maline i jakim osećajem nikotina. Uživajte u bezbednom i prijatnom iskustvu sa snus proizvodom.",
    cover_img: require("./assets/images/products/iceberg-raspberry.webp"),
    keywords: "snus online",
  },
  {
    id: 23,
    title: "Grape Gum Slim Extreme",
    category: "ICEBERG",
    meta_description:
      "Isprobajte ICEBERG Grape Gum Slim Extreme nikotinski proizvod sa jakim ukusom grožđa i ekstremnim osećajem nikotina. Naručite ovaj snus sa osvežavajućim ukusom grožđa putem naše snus online prodavnice i uživajte u svakom trenutku.",
    cover_img: require("./assets/images/products/iceberg-grape-gum-slim-extreme.webp"),
    keywords: "snus sa ukusom grožđa",
  },
  {
    id: 24,
    title: "Energy Slim Extra Strong",
    category: "ICEBERG",
    meta_description:
      "ICEBERG Energy Slim Extra Strong je nikotinski proizvod sa visokim nivoom kofeina i taurina koji pruža intenzivnu energiju i snažan osećaj nikotina. Isprobajte sada i uživajte u neverovatnom ukusu i energiji!",
    cover_img: require("./assets/images/products/iceberg-energy.webp"),
    keywords: "snus proizvod, snus ukus",
  },
  {
    id: 25,
    title: "Winter Chill Slim Extra Strong",
    category: "VELO",
    meta_description:
      "VELO Winter Chill Slim Extra Strong je nikotinski proizvod bez duvana koji pruža snažan osećaj nikotina i osvežavajući ukus mente. Isprobajte sada i uživajte u intenzivnom iskustvu VELO Winter Chill Slim Extra Strong - snus prodaja snus srbija!",
    cover_img: require("./assets/images/products/velo-winter-chill.webp"),
    keywords: "snus prodaja, nikotinski proizvod",
  },
  {
    id: 26,
    title: "Freeze Slim ULTRA",
    category: "VELO",
    meta_description:
      "Otkrijte ultimativno iskustvo nikotina sa VELO Mighty Peppermint ULTRA. Sa ultra jakom formulom i prodornim mentolom, VELO ULTRA pruža vrhunsku svežinu i zadovoljstvo bez dima. Idealno za one koji traže snažnu i dugotrajnu alternativu pušenju, bilo gde i bilo kad.",
    cover_img: require("./assets/images/products/velo-mighty-peppermint-ultra.webp"),
    keywords: "snus online",
  },
  {
    id: 27,
    title: "All White Portion Extremely Strong",
    category: "SIBERIA",
    meta_description:
      "SIBERIA All White Portion Extremely Strong je nikotinski proizvod bez duvana sa najjačom dozom nikotina koju možete pronaći na tržištu. Isprobajte sada i osetite neverovatno snažan osećaj nikotina uz osvežavajući ukus mente!",
    cover_img: require("./assets/images/products/siberia-all-white.webp"),
    keywords: "najjači nikotinski proizvod",
  },
  {
    id: 28,
    title: "Groovy Grape",
    category: "VELO",
    meta_description:
      "Otkrijte VELO Groovy Grape nikotinske vrećice: bogat ukus grožđa, bezdimno zadovoljstvo i diskretno iskustvo. Savršen izbor za ljubitelje nikotina koji cene kvalitet i eleganciju",
    cover_img: require("./assets/images/products/velo-groovy-grape.webp"),
    keywords: "snus serbia, nikotinski proizvod",
  },
  {
    id: 29,
    title: "Fresh Jalapeno",
    category: "VELO",
    meta_description:
      "VELO Fresh Jalapeno je nikotinski proizvod bez duvana koji kombinuje pikantni ukus jalapenosa sa snažnim osećajem nikotina. Isprobajte sada VELO Fresh Jalapeno i osvežite svoje čulo ukusa! Snus Serbia",
    cover_img: require("./assets/images/products/velo-fresh-jalapeno.webp"),
    keywords: "snus serbia",
  },
  {
    id: 30,
    title: "Frosty Grapefruit",
    category: "VELO",
    meta_description:
      "VELO Frosty Grapefruit je nikotinski proizvod bez duvana koji pruža osvežavajući ukus grejpfruta i snažan osećaj nikotina. Isprobajte sada VELO Frosty Grapefruit i uživajte u harmoničnom spoju citrusa i nikotina!",
    cover_img: require("./assets/images/products/velo-frosty-grapefruit.webp"),
    keywords: "snus serbia, nikotinski proizvod, grejpfrut, citrusi",
  },
  {
    id: 31,
    title: "Elderflower Spritz",
    category: "VELO",
    meta_description:
      "VELO Elderflower Spritz je nikotinski proizvod bez duvana koji pruža osvežavajući ukus cveta bazge i snažan osećaj nikotina. Isprobajte sada VELO Elderflower Spritz i uživajte u neodoljivoj kombinaciji cvetnog ukusa i nikotina! snus prodaja beograd",
    cover_img: require("./assets/images/products/velo-elderflower-spritz.webp"),
    keywords: ", snus beograd, cvetni ukus",
  },
  {
    id: 32,
    title: "Black Currant",
    category: "LYFT",
    meta_description:
      "LYFT Black Currant je nikotinski proizvod bez duvana koji pruža ukus zrele crne ribizle i snažan osećaj nikotina. Isprobajte sada LYFT Black Currant i uživajte u intenzivnom voćnom ukusu uz nikotinski stimulans!",
    cover_img: require("./assets/images/products/lyft-black-currant.webp"),
    keywords: "crna ribizla, voćni ukus, nikotin",
  },
  {
    id: 33,
    title: "Breezy Mango Slim",
    category: "VELO",
    meta_description:
      "Iskusite osveženje manga sa Velo Breezy Mango Slim nikotinskim vrećicama. Bezdimno, diskretno, sa savršenom dozom nikotina. Idealno za modernog korisnika koji teži kvalitetu i stilu.",
    cover_img: require("./assets/images/products/velo-breezy-mango.webp"),
    keywords: "snus srbija",
  },
  {
    id: 34,
    title: "Maradona",
    category: "FEDRS",
    meta_description:
      "Isprobajte FEDRS Maradona nikotinski proizvod posvećen fudbalskoj legendi Dijegu Maradoni. Uživajte u jedinstvenom ukusu i snažnom osećaju nikotina. Kupite ovaj poseban snus proizvod sada i odaćemo počast nezaboravnom Maradoni!",
    cover_img: require("./assets/images/products/fedrs-maradona.webp"),
    keywords: "fudbalska legenda, snus online prodavnica",
  },
  {
    id: 35,
    title: "Dragon Fire",
    category: "ICEBERG",
    meta_description:
      "Isprobajte ICEBERG Dragon Fire nikotinski proizvod sa intenzivnim ukusom voća i začinjenom notom. Osetite snažan osećaj nikotina i uživajte u eksploziji ukusa. Kupite ovaj poseban snus proizvod sada i otkrijte novu dimenziju ukusa!",
    cover_img: require("./assets/images/products/iceberg-dragon-fire.webp"),
    keywords: "nikotinski proizvod, voćni ukus",
  },
  {
    id: 36,
    title: "Kiwi Strawberry",
    category: "ICEBERG",
    meta_description:
      "Uživajte u savršenoj kombinaciji voćnog ukusa kiwija i jagode sa ICEBERG Kiwi Strawberry nikotinskim proizvodom. Bez duvana i neprijatnih mirisa. Kupite ovaj proizvod sada i otkrijte novu dimenziju ukusa!",
    cover_img: require("./assets/images/products/iceberg-kiwi-strawberry.webp"),
    keywords: "snus beograd",
  },
  {
    id: 37,
    title: "Menthol",
    category: "ICEBERG",
    meta_description:
      "ICEBERG Menthol nikotinske kesice – osvežavajuća menta, na stanju. Povoljna cena i brza dostava širom Srbije.",
    cover_img: require("./assets/images/products/iceberg-menthol.webp"),
    keywords: "iceberg menthol cena, iceberg snus prodaja, brza dostava",
  },
  {
    id: 38,
    title: "Arasaka",
    category: "ICEBERG",
    meta_description:
      "Otkrijte futuristički ukus sa ICEBERG Arasaka nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji ukusa i snažnom osećaju nikotina. Poručite ovaj proizvod sada i istražite novu dimenziju ukusa!",
    cover_img: require("./assets/images/products/iceberg-arasaka.webp"),
    keywords: "snus serbia",
  },
  {
    id: 39,
    title: "Ninja Orange",
    category: "ICEBERG",
    meta_description:
      "Probajte hrabro voće sa ICEBERG Ninja Orange nikotinskim proizvodom. Uživajte u svežem ukusu narandže i intenzivnom osećaju nikotina. Kupite ovaj proizvod sada i uđite u svet osveženja!",
    cover_img: require("./assets/images/products/iceberg-ninja-orange.webp"),
    keywords: "nikotinski proizvodi",
  },
  {
    id: 40,
    title: "Double Apple",
    category: "ICEBERG",
    meta_description:
      "Osetite harmoniju ukusa jabuke sa ICEBERG Double Apple nikotinskim proizvodom. Uživajte u svežem i slatkom ukusu jabuke i snažnom osećaju nikotina. Poručite ovaj proizvod sada i doživite dvostruko zadovoljstvo!",
    cover_img: require("./assets/images/products/iceberg-double-apple.webp"),
    keywords: "snus online",
  },
  {
    id: 41,
    title: "Cola",
    category: "ICEBERG",
    meta_description:
      "Doživite osveženje uz ICEBERG Cola nikotinski proizvod sa ukusom vašeg omiljenog gaziranog pića. Uživajte u slatkom ukusu kole i jakom osećaju nikotina. Kupite ovaj proizvod sada i osvežite se na novi način!",
    cover_img: require("./assets/images/products/iceberg-cola.webp"),
    keywords: "snus online",
  },
  {
    id: 42,
    title: "Ice Cold XXL",
    category: "PABLO",
    meta_description:
      "Uživajte u ledeno svežem osećaju sa PABLO Ice Cold XXL nikotinskim proizvodom. Sa jakim hladnim ukusom, ovaj proizvod će vas rashladiti i osvežiti. Kupite ovaj proizvod sada i doživite ekstremnu svežinu!",
    cover_img: require("./assets/images/products/pablo-ice-cold-xxl.webp"),
    keywords: "snus online prodavnica",
  },
  {
    id: 43,
    title: "Frosted Mint",
    category: "PABLO",
    meta_description:
      "Isprobajte PABLO Frosted Mint nikotinski proizvod sa hladnim i osvežavajućim ukusom mente. Uživajte u snažnom osećaju nikotina i diskretnom načinu konzumiranja. Kupite ovaj proizvod sada i doživite intenzivnu svežinu!",
    cover_img: require("./assets/images/products/pablo-frosted-mint.webp"),
    keywords: "snus online prodavnica",
  },
  {
    id: 44,
    title: "Fatality Brutal Fruity Gum",
    category: "KURWA",
    meta_description:
      "Isprobajte Kurwa Fatality Brutal Fruity Gum nikotinski proizvod sa ekstremno voćnim ukusom i intenzivnim osećajem nikotina. Uživajte u brutalnom iskustvu i diskretnom načinu konzumiranja. Kupite ovaj proizvod sada i doživite voćnu eksploziju!",
    cover_img: require("./assets/images/products/kurwa-fatality-brutal-fruity-gum.webp"),
    keywords: "KURWA",
  },
  {
    id: 45,
    title: "Blackcurrant Purple Grape",
    category: "KURWA",
    meta_description:
      "Osetite dubok i intenzivan ukus crne ribizle i ljubičaste grožđice sa Kurwa Blackcurrant Purple Grape nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i snažnom osećaju nikotina. Kupite ovaj proizvod sada i istražite voćni raj!",
    cover_img: require("./assets/images/products/kurwa-blackcurrant-purple-grape.webp"),
    keywords: "snus ukusi, snus prodavnica",
  },
  // 10.10.2023.
  {
    id: 46,
    title: "Bubblegum",
    category: "KURWA",
    meta_description:
      "Osetite slatki i živahni ukus žvakaće gume sa Kurwa Bubblegum nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i osvežavajućem osećaju nikotina. Kupite ovaj proizvod sada i istražite svet žvakaće gume!",
    cover_img: require("./assets/images/products/kurwa-bubblegum.webp"),
    keywords: "žvakaća guma, snus povoljno",
  },
  {
    id: 47,
    title: "Grape",
    category: "ICEBERG",
    meta_description:
      "Iskusite osvežavajući i intenzivan ukus grožđa sa Iceberg Grape nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i snažnom osećaju nikotina. Nabavite ovaj proizvod odmah i otkrijte voćnu eksploziju!",
    cover_img: require("./assets/images/products/iceberg-grape.webp"),
    keywords: "snus beograd",
  },
  {
    id: 48,
    title: "Crazy Mix",
    category: "ICEBERG",
    meta_description:
      "Probajte šareni miks ukusa sa Iceberg Crazy Mix nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i osvežavajućem osećaju nikotina. Kupite ovaj proizvod sada i istražite raznovrsne voćne arome!",
    cover_img: require("./assets/images/products/iceberg-crazy-mix.webp"),
    keywords: "snus Novi Sad, voćni mix",
  },
  {
    id: 49,
    title: "Coconut",
    category: "ICEBERG",
    meta_description:
      "Osetite egzotični ukus kokosa sa Iceberg Coconut nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i osvežavajućem osećaju nikotina. Nabavite ovaj proizvod odmah i putujte ka tropskom raju!",
    cover_img: require("./assets/images/products/iceberg-coconut.webp"),
    keywords: "snus na malo, kokos",
  },

  {
    id: 50,
    title: "Bubblegum",
    category: "ICEBERG",
    meta_description:
      "Iskusite slatki i živahni ukus žvakaće gume sa Iceberg Bubblegum nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i osvežavajućem osećaju nikotina. Kupite ovaj proizvod sada i doživite svet žvakaće gume!",
    cover_img: require("./assets/images/products/iceberg-bubblegum.webp"),
    keywords: "žvakaća guma, online snus",
  },
  {
    id: 51,
    title: "Dragon Fruit",
    category: "ICEBERG",
    meta_description:
      "Iskusite egzotični ukus pitaje voća sa Iceberg Dragon Fruit nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i osvežavajućem osećaju nikotina. Nabavite ovaj proizvod odmah i otputujte u voćnu avanturu!",
    cover_img: require("./assets/images/products/iceberg-dragon-fruit.webp"),
    keywords: "snus voće",
  },
  {
    id: 52,
    title: "Strawberry Mango Gum",
    category: "ICEBERG",
    meta_description:
      "Osetite slatko-voćni miks jagode i manga sa Iceberg Strawberry Mango Gum nikotinskim proizvodom. Uživajte u jedinstvenoj kombinaciji i osvežavajućem osećaju nikotina. Kupite ovaj proizvod sada i doživite voćni eksploziju!",
    cover_img: require("./assets/images/products/iceberg-strawberry-mango-gum.webp"),
    keywords: "jagoda, mango, žvakaća guma",
  },

  {
    id: 53,
    title: "Emerald",
    category: "ICEBERG",
    meta_description:
      "ICEBERG Emerald nikotinske kesice – osvežavajuća, ledena kombinacija, na stanju. Naručite po povoljnoj ceni uz brzu dostavu.",
    cover_img: require("./assets/images/products/iceberg-emerald.webp"),
    keywords: "iceberg emerald cena, iceberg snus prodaja, brza dostava",
  },

  {
    id: 54,
    title: "Cold Mint",
    category: "KILLA",
    meta_description:
      "Iskusite intenzivan i hladan ukus mente sa Killa Cold Mint nikotinskim proizvodom. Nabavite ovaj proizvod odmah i osvežite svoje nepce!",
    cover_img: require("./assets/images/products/killa-cold-mint.webp"),
    keywords: "menta, nikotinski proizvod",
  },

  {
    id: 55,
    title: "Blue Ice",
    category: "RABBIT",
    meta_description:
      "Osetite osvežavajući ukus sa Rabbit Blue Ice nikotinskim proizvodom. Nabavite ovaj proizvod odmah i doživite ledenu eksploziju!",
    cover_img: require("./assets/images/products/rabbit-blue-ice.webp"),
    keywords: "svežina, nikotinski proizvod",
  },

  {
    id: 56,
    title: "Exclusive Banana Ice",
    category: "PABLO",
    meta_description:
      "Iskusite ekskluzivni ukus banane sa Pablo Exclusive Banana Ice nikotinskim proizvodom. Nabavite ovaj proizvod odmah i uživajte u jedinstvenoj voćnoj kombinaciji!",
    cover_img: require("./assets/images/products/pablo-banana-ice.webp"),
    keywords: "snus banana, ekskluzivni, pablo snus banana",
  },

  {
    id: 57,
    title: "Exclusive Mango Ice",
    category: "PABLO",
    meta_description:
      "Doživite intenzivni ukus manga sa Pablo Exclusive Mango Ice nikotinskim proizvodom. Nabavite ovaj proizvod odmah i uživajte u egzotičnom voćnom doživljaju!",
    cover_img: require("./assets/images/products/pablo-mango-ice.webp"),
    keywords: "snus mango, pablo snus mango",
  },
  {
    id: 58,
    title: "Dark Forest",
    category: "THUNDER",
    meta_description:
      "Doživite duboku notu šume sa Thunder Dark Forest nikotinskim proizvodom. Kupite online ovaj proizvod odmah i uživajte u intenzivnom doživljaju prirode!",
    cover_img: require("./assets/images/products/thunder-dark-forest.webp"),
    keywords: "snus šuma, intenzivan snus",
  },

  {
    id: 59,
    title: "Deep Freeze",
    category: "THUNDER",
    meta_description:
      "Iskusite intenzivni efekat leda sa Thunder Deep Freeze nikotinskim proizvodom. Kupite onlajn ovaj proizvod odmah i osvežite svoj ukus!",
    cover_img: require("./assets/images/products/thunder-deep-freeze.webp"),
    keywords: "led, snus osvežavajuće",
  },

  {
    id: 60,
    title: "Cinnamon Flame",
    category: "VELO",
    meta_description:
      "Osetite toplu notu cimeta sa VELO Cinnamon Flame nikotinskim proizvodom. Nabavite ovaj proizvod odmah i uživajte u blagom i toplo ukusu!",
    cover_img: require("./assets/images/products/velo-cinnamon-flame.webp"),
    keywords: "snus cimet, snus topao",
  },

  {
    id: 61,
    title: "McLaren Watermelon",
    category: "VELO",
    meta_description:
      "Iskusite ukus sočne lubenice sa VELO McLaren Watermelon nikotinskim proizvodom. Nabavite ovaj proizvod odmah i osvežite svoj ukus!",
    cover_img: require("./assets/images/products/velo-mclaren-watermelon.webp"),
    keywords: "snus lubenica, snus osvežavajuće",
  },

  {
    id: 62,
    title: "Deep Freeze",
    category: "VOLT",
    meta_description:
      "Doživite intenzivan efekat leda sa VOLT Deep Freeze nikotinskim proizvodom. Nabavite ovaj proizvod odmah i osvežite svoj ukus!",
    cover_img: require("./assets/images/products/volt-deep-freeze.webp"),
    keywords: "snus led",
  },
  {
    id: 63,
    title: "Icy Berries",
    category: "VELO",
    meta_description:
      "Otkrijte svežinu šumskih bobica sa VELO Icy Berries nikotinskim proizvodom. Nabavite ovaj osvežavajući proizvod odmah!",
    cover_img: require("./assets/images/products/velo-icy-berries.webp"),
    keywords: "snus šumske bobice, snus osvežavajuće, snus hladno",
  },
  {
    id: 64,
    title: "Orange Spark",
    category: "VELO",
    meta_description:
      "Doživite osvežavajuću eksploziju ukusa sa VELO Orange Spark, savršenim spojem slatke narandže i osvežavajućih citrusnih nota.",
    cover_img: require("./assets/images/products/velo_orange_spark.webp"),
    keywords: " narandža, osvežavajuće, citrus",
  },

  {
    id: 65,
    title: "Zest Flame",
    category: "VELO",
    meta_description:
      "Pronađite savršeni balans između vatrenih začina i osvežavajućih citrusnih aroma sa VELO Zest Flame.",
    cover_img: require("./assets/images/products/velo_zest_flame.webp"),
    keywords: "citrus, začinjeno, intenzivno",
  },

  {
    id: 66,
    title: "Lime Flame",
    category: "VELO",
    meta_description:
      "Uživajte u jedinstvenoj kombinaciji osvežavajuće limete i blagih začinskih nota sa VELO Lime Flame.",
    cover_img: require("./assets/images/products/velo_lime_flame.webp"),
    keywords: " limeta, osvežavajuće, blago začinjeno",
  },

  {
    id: 67,
    title: "Mango Flame",
    category: "VELO",
    meta_description:
      "Iskusite tropsku slatkoću manga sa začinskim obrtom uz VELO Mango Flame.",
    cover_img: require("./assets/images/products/velo_mango_flame.webp"),
    keywords: " mango, tropsko, slatko, začinjeno",
  },
  {
    id: 68,
    title: "Extreme Raspberry",
    category: "GARANT",
    meta_description:
      "Otkrijte intenzivnu aromu maline sa Garant Extreme Raspberry nikotinskim vrećicama.",
    cover_img: require("./assets/images/products/grant_extreme_raspberry.webp"),
    keywords: "malina, intenzivno, voćno, osvežavajuće",
  },

  {
    id: 69,
    title: "Extreme Cherry",
    category: "GARANT",
    meta_description:
      "Zaronite u duboki ukus višnje sa Garant Extreme Cherry nikotinskim vrećicama.",
    cover_img: require("./assets/images/products/grant_extreme_cherry.webp"),
    keywords: "višnja, bogato, intenzivno, voćno",
  },

  {
    id: 70,
    title: "Extreme Grape",
    category: "GARANT",
    meta_description:
      "Iskusite bogatstvo ukusa grožđa sa Garant Extreme Grape nikotinskim vrećicama.",
    cover_img: require("./assets/images/products/grant_extreme_grape.webp"),
    keywords: "grožđe, bogato, voćno, nikotin",
  },

  {
    id: 71,
    title: "Extreme Energy Drink",
    category: "GARANT",
    meta_description:
      "Probudite se sa energizirajućim ukusom energetskog pića uz Garant Extreme Energy Drink vrećice.",
    cover_img: require("./assets/images/products/grant_extreme_energy_drink.webp"),
    keywords: "energetski napitak, osvežavajuće, stimulativno, intenzivno",
  },

  {
    id: 72,
    title: "Tangled Berry",
    category: "VELO",
    meta_description:
      "Uživajte u sočnoj mešavini bobica sa Velo Tangled Berry nikotinskim vrećicama.",
    cover_img: require("./assets/images/products/velo_tangled_berry.webp"),
    keywords: "bobičasto voće, slatko, voćno, osvežavajuće",
  },

  {
    id: 73,
    title: "Cool Mint Slim Extreme Strong",
    category: "ZYN",
    meta_description:
      "Doživite ekstremnu svežinu mente sa ZYN Cool Mint Slim Extreme Strong nikotinskim vrećicama.",
    cover_img: require("./assets/images/products/zyn_cool_mint_extreme_strong.webp"),
    keywords: "menta, sveže, ekstremno, jaka",
  },
  {
    id: 74,
    title: "Twisted Pineapple",
    category: "VELO",
    meta_description:
      "Uživajte u tropskom ukusu ananasa sa Velo Twisted Pineapple nikotinskim vrećicama.",
    cover_img: require("./assets/images/products/VELO-TwistedPineapple_Top-2400x2400.webp"),
    keywords: "ukus ananasa, tropski",
  },
  {
    id: 75,
    title: "Wintery Waterlemon Mini",
    category: "VELO",
    meta_description:
      "Osetite osvežavajuću kombinaciju lubenice i hladnog podtona sa Velo Wintery Waterlemon Mini.",
    cover_img: require("./assets/images/products/VELO-WinteryWatermelon_Top-2400x2400.webp"),
    keywords: "lubenica, blagi ukus, zimski",
  },
  {
    id: 76,
    title: "Breezy Mango High Nic",
    category: "VELO",
    meta_description:
      "Iskusite snažan nikotinski užitak uz neodoljivi ukus zrelog manga sa Velo Breezy Mango High Nic.",
    cover_img: require("./assets/images/products/VELO-BreezyMango_Top-2400x2400.webp"),
    keywords: "mango, visoki nikotin, osvežavajući",
  },
  {
    id: 77,
    title: "Icy Cherry",
    category: "VELO",
    meta_description:
      "Uživajte u osvežavajućem ukusu trešnje sa ledenim efektom sa Velo Icy Cherry.",
    cover_img: require("./assets/images/products/VELO-Icy-Cherry_Top-2400x2400.webp"),
    keywords: "trešnja, led, osvežavajući",
  },
  {
    id: 78,
    title: "Black Watermelon",
    category: "CUBA",
    meta_description:
      "Cuba Black Watermelon pruža bogat i sladak ukus lubenice sa tamnim tonovima.",
    cover_img: require("./assets/images/products/cuba-black-watermelon-front.webp"),
    keywords: "lubenica, voćni, intenzivan",
  },
  {
    id: 79,
    title: "All White Portion",
    category: "WHITE FOX",
    meta_description:
      "White Fox All White Portion nudi čisto nikotinsko iskustvo sa osvežavajućim mentolom.",
    cover_img: require("./assets/images/products/white_fox_all_white.webp"),
    keywords: "mentol, osvežavajuće, čisto",
  },
  {
    id: 80,
    title: "Black Edition",
    category: "WHITE FOX",
    meta_description:
      "White Fox Black Edition donosi snažno nikotinsko iskustvo sa bogatim i punim ukusom.",
    cover_img: require("./assets/images/products/white-fox-black72_medium.webp"),
    keywords: "intenzivno, bogato, crno",
  },
  {
    id: 81,
    title: "Full Charge",
    category: "WHITE FOX",
    meta_description:
      "White Fox Full Charge – jak mentolski ukus i visok sadržaj nikotina, na stanju. Poručite odmah uz brzu dostavu i povoljnu cenu.",
    cover_img: require("./assets/images/products/white_fox_full_charge_medium.webp"),
    keywords: "white fox full charge cena, white fox snus prodaja, brza dostava",
  },
  {
    id: 82,
    title: "Peppered Mint",
    category: "WHITE FOX",
    meta_description:
      "White Fox Peppered Mint pruža osvežavajući i papreni ukus nane sa intenzivnim nikotinskim udarcem.",
    cover_img: require("./assets/images/products/white_fox_peppermint.webp"),
    keywords: "nana, papreno, mentol",
  },
  {
    id: 83,
    title: "Black Cola",
    category: "CUBA",
    meta_description:
      "Cuba Black Cola donosi autentičan i osvežavajući ukus kole sa blagim tonovima karamele i citrusa.",
    cover_img: require("./assets/images/products/cuba-black-cola.webp"),
    keywords: "kola, osvežavajući, klasičan",
  },
  {
    id: 83,
    title: "Black Cherry Slim",
    category: "CUBA",
    meta_description:
      "Cuba Black Cherry Slim nudi intenzivan i sočan ukus crne višnje sa notama zrelog voća.",
    cover_img: require("./assets/images/products/cuba-black-cherry-slim.webp"),
    keywords: "višnja, voćni, sočan",
  },
  {
    id: 84,
    title: "Black Peach",
    category: "CUBA",
    meta_description:
      "Cuba Black Peach pruža sočan i sladak ukus zrele breskve sa blagim notama voćnog osveženja.",
    cover_img: require("./assets/images/products/cuba-black-peach.webp"),
    keywords: "breskva, slatko, osvežavajuće",
  },
  {
    id: 85,
    title: "Black Pineapple",
    category: "CUBA",
    meta_description:
      "Cuba Black Pineapple donosi tropsku eksploziju ukusa sa intenzivnim i osvežavajućim notama zrelog ananasa.",
    cover_img: require("./assets/images/products/cuba-black-pineapple.webp"),
    keywords: "ananasa, tropski, osvežavajući",
  },
  {
    id: 86,
    title: "Black Currant",
    category: "CUBA",
    meta_description:
      "Cuba Black Currant donosi bogat i osvežavajući ukus crne ribizle sa laganim kiselkastim notama.",
    cover_img: require("./assets/images/products/cuba-black-currant.webp"),
    keywords: "crna ribizla, voćni, osvežavajuće",
  },
  {
    id: 87,
    title: "Black Blueberry",
    category: "CUBA",
    meta_description:
      "Cuba Black Blueberry donosi zavodljiv ukus zrelih borovnica sa blagim tonovima prirodne slatkoće i osvežavajuće kiselosti.",
    cover_img: require("./assets/images/products/cuba-black-blueberry.webp"),
    keywords: "borovnica, voćni, sladak",
  },
  {
    id: 88,
    title: "Ninja Energy",
    category: "CUBA",
    meta_description:
      "Cuba Ninja Energy donosi snažnu i osvežavajuću aromu inspirisanu popularnim energetskim napicima.",
    cover_img: require("./assets/images/products/cuba-ninja-energy-front.webp"),
    keywords: "energetski, osvežavajuće, snažno",
  },
  {
    id: 89,
    title: "Ice Cold Mint",
    category: "CAMO",
    meta_description:
      "CAMO Ice Cold Mint pruža intenzivno osvežavajuće iskustvo sa savršenim spojem mentola i ledenih tonova.",
    cover_img: require("./assets/images/products/Camo-Ice-Cold-Mint-6mg.webp"),
    keywords: "menta, osvežavajuće, ledeno",
  },
  {
    id: 90,
    title: "Wild Mint",
    category: "CAMO",
    meta_description:
      "CAMO Wild Mint donosi jedinstvenu kombinaciju divljeg mentola i prirodnih tonova, pružajući osvežavajuće i bogato iskustvo.",
    cover_img: require("./assets/images/products/Camo-Wild-Mint-6mg.webp"),
    keywords: "menta, divlji, prirodni",
  },
  {
    id: 91,
    title: "Peppermint",
    category: "CAMO",
    meta_description:
      "CAMO Peppermint pruža nežnu, ali osvežavajuću kombinaciju slatkog i aromatičnog peperminta.",
    cover_img: require("./assets/images/products/Camo-Peppermint-6mg.webp"),
    keywords: "pepermint, osvežavajuće, slatko",
  },
  {
    id: 92,
    title: "Spicy Citrus",
    category: "CAMO",
    meta_description:
      "CAMO Spicy Citrus spaja osvežavajuće citrusne note sa toplim začinskim tonovima.",
    cover_img: require("./assets/images/products/Camo-Spicy-Citrus-6mg.webp"),
    keywords: "citrus, začinsko, osvežavajuće",
  },
  {
    id: 93,
    title: "Cola",
    category: "RABBIT",
    meta_description:
      "Rabbit Cola donosi bogat i autentičan ukus klasične kole, savršen za ljubitelje tradicionalnih i osvežavajućih aroma.",
    cover_img: require("./assets/images/products/rabbit-cola-front.webp"),
    keywords: "kola, tradicionalno, osvežavajuće",
  },
  {
    id: 94,
    title: "Pepper Mint Extreme",
    category: "RABBIT",
    meta_description:
      "RaBBiT Pepper Mint Extreme kombinuje osvežavajuću mentu sa toplim začinskim tonovima za jedinstveno i snažno iskustvo.",
    cover_img: require("./assets/images/products/rabbit-pepper-mint-extreme-front.webp"),
    keywords: "menta, začinsko, intenzivno",
  },
  {
    id: 95,
    title: "Tropical Mint Slim Medium",
    category: "77",
    meta_description:
      "77 Tropical Mint Slim Medium Nicotine Pouches donosi ukusnu kombinaciju tropskih nota i osvežavajuće mente. Idealno za one koji traže zdraviju alternativu.",
    cover_img: require("./assets/images/products/77-tropical-mint-medium-front.webp"),
    keywords: "tropska menta, nikotin, bez duvana",
  },
  {
    id: 96,
    title: "Cola Cherry Medium",
    category: "77",
    meta_description:
      "77 Cola Cherry Medium kombinuje osvežavajuću aromu kole sa bogatim ukusom višnje.",
    cover_img: require("./assets/images/products/77-cola-cherry-medium-front.webp"),
    keywords: "kola, višnja, nikotin, osvežavajuće",
  },
  {
    id: 97,
    title: "Cola Vanilla Medium",
    category: "77",
    meta_description:
      "77 Cola Vanilla Medium donosi kremastu kombinaciju vanile i klasične kole.",
    cover_img: require("./assets/images/products/77-cola-vanilla-medium-front.webp"),
    keywords: "kola, vanila, nikotin, osvežavajuće",
  },
  {
    id: 98,
    title: "Watermelon Ice Medium",
    category: "77",
    meta_description:
      "77 Watermelon Ice Medium spaja slatki ukus lubenice sa ledenim osveženjem.",
    cover_img: require("./assets/images/products/77-watermelon-ice-medium-front.webp"),
    keywords: "lubenica, ledeno, nikotin, osvežavajuće",
  },
  {
    id: 99,
    title: "Energy Mango",
    category: "Iceberg",
    meta_description:
      "Iceberg Energy Mango kombinuje slatkoću manga sa energizirajućim tonovima za osveženje.",
    cover_img: require("./assets/images/products/iceberg-energy-mango-front.webp"),
    keywords: "mango, energija, nikotin, egzotično",
  },
  {
    id: 100,
    title: "Grapefruit Pineapple",
    category: "Iceberg",
    meta_description:
      "Iceberg Grapefruit Pineapple donosi harmoničan spoj grejpa i ananasa za jedinstveno iskustvo.",
    cover_img: require("./assets/images/products/iceberg-grapefruit-pineapple-front.webp"),
    keywords: "grejp, ananas, nikotin, osvežavajuće",
  },
  {
    id: 101,
    title: "Exclusive Grape Ice",
    category: "PABLO",
    meta_description:
      "Exclusive Grape Ice donosi intenzivan ukus grožđa sa osvežavajućim tonovima leda.",
    cover_img: require("./assets/images/products/pablo-exclusive-grape-ice-front.webp"),
    keywords: "grožđe, led, nikotin, osvežavajuće, snussrbija, online prodaja",
  },
  {
    id: 102,
    title: "Exclusive Kiwi",
    category: "PABLO",
    meta_description:
      "Exclusive Kiwi nudi osvežavajuću kombinaciju ukusa kivija za jedinstveno iskustvo.",
    cover_img: require("./assets/images/products/pablo-exclusive-kiwi-front.webp"),
    keywords: "kivi, osvežavajuće, nikotin, voćno, snussrbija, online prodaja",
  },
  {
    id: 103,
    title: "Exclusive Passion Fruit",
    category: "PABLO",
    meta_description:
      "Exclusive Passion Fruit pruža egzotičan i osvežavajući ukus marakuje.",
    cover_img: require("./assets/images/products/pablo-exclusive-passion-fruit-front.webp"),
    keywords:
      "marakuja, egzotično, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 104,
    title: "Exclusive Strawberry Lychee",
    category: "PABLO",
    meta_description:
      "Exclusive Strawberry Lychee spaja bogat ukus jagode i egzotičnog ličija.",
    cover_img: require("./assets/images/products/pablo-exclusive-strawberry-lychee-front.webp"),
    keywords:
      "jagoda, liči, egzotično, nikotin, osvežavajuće, snussrbija, online prodaja",
  },
  {
    id: 105,
    title: "Black Banana Hit",
    category: "CUBA",
    meta_description:
      "Black Banana Hit nudi unikatnu kombinaciju crne banane i bogatih aroma.",
    cover_img: require("./assets/images/products/cuba-black-banana-hit-front.webp"),
    keywords: "banana, bogato, intenzivno, nikotin, snussrbija, online prodaja",
  },
  {
    id: 106,
    title: "Black Ice Spearmint",
    category: "CUBA",
    meta_description:
      "Black Ice Spearmint donosi osvežavajuću kombinaciju spearmint mente i ledenih tonova.",
    cover_img: require("./assets/images/products/cuba-black-ice-spearmint-front.webp"),
    keywords:
      "spearmint, led, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 107,
    title: "Coca Leaf",
    category: "CUBA",
    meta_description:
      "Coca Leaf donosi autentičan ukus listova koke za intenzivno iskustvo.",
    cover_img: require("./assets/images/products/cuba-coca-leaf-front.webp"),
    keywords:
      "koka, autentično, intenzivno, nikotin, snussrbija, online prodaja",
  },
  {
    id: 108,
    title: "Ninja Ice Cool",
    category: "CUBA",
    meta_description:
      "Ninja Ice Cool kombinuje osvežavajuće arome sa intenzivnim efektom hlađenja.",
    cover_img: require("./assets/images/products/cuba-ninja-ice-cool-front.jpg"),
    keywords:
      "hladno, osvežavajuće, nikotin, intenzivno, snussrbija, online prodaja",
  },
  {
    id: 109,
    title: "Black Double Fresh",
    category: "CUBA",
    meta_description:
      "Black Double Fresh nudi intenzivnu kombinaciju dvostruke svežine za osvežavajuće iskustvo.",
    cover_img: require("./assets/images/products/cuba-black-double-fresh-front.webp"),
    keywords:
      "dvostruko, sveže, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 110,
    title: "White Cherry",
    category: "CUBA",
    meta_description:
      "White Cherry donosi sladak i sočan ukus trešnje sa blagim osvežavajućim tonovima.",
    cover_img: require("./assets/images/products/cuba-white-cherry-front.webp"),
    keywords:
      "trešnja, slatko, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 111,
    title: "White Cola",
    category: "CUBA",
    meta_description:
      "White Cola pruža autentičan ukus kole sa blagim osvežavajućim efektom.",
    cover_img: require("./assets/images/products/cuba-white-cola-front.webp"),
    keywords:
      "kola, osvežavajuće, nikotin, autentično, snussrbija, online prodaja",
  },
  {
    id: 112,
    title: "White Watermelon",
    category: "CUBA",
    meta_description:
      "White Watermelon nudi osvežavajući i sladak ukus sočne lubenice.",
    cover_img: require("./assets/images/products/cuba-white-watermelon-front.webp"),
    keywords:
      "lubenica, slatko, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 113,
    title: "White Pineapple",
    category: "CUBA",
    meta_description:
      "White Pineapple donosi tropski i sladak ukus ananasa za egzotično iskustvo.",
    cover_img: require("./assets/images/products/cuba-white-pineapple-front.webp"),
    keywords: "ananas, tropsko, slatko, nikotin, snussrbija, online prodaja",
  },
  {
    id: 114,
    title: "White Ice Spearmint",
    category: "CUBA",
    meta_description:
      "White Ice Spearmint kombinuje osvežavajući efekat spearmint mente sa blagim tonovima.",
    cover_img: require("./assets/images/products/cuba-white-ice-spearmint-front.webp"),
    keywords:
      "spearmint, osvežavajuće, nikotin, blago, snussrbija, online prodaja",
  },
  {
    id: 115,
    title: "White Forest Berries",
    category: "CUBA",
    meta_description:
      "White Forest Berries nudi bogat i osvežavajući ukus šumskog voća.",
    cover_img: require("./assets/images/products/cuba-white-forest-berries-front.webp"),
    keywords:
      "šumsko voće, voćno, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 116,
    title: "White Double Fresh",
    category: "CUBA",
    meta_description:
      "White Double Fresh nudi intenzivnu svežinu dvostruke arome za osvežavajuće iskustvo.",
    cover_img: require("./assets/images/products/cuba-white-double-fresh-front.webp"),
    keywords:
      "dvostruko, sveže, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 117,
    title: "Spearmint Slim Strong",
    category: "ZYN",
    meta_description:
      "Spearmint Slim Strong donosi intenzivnu aromu spearminta u praktičnom slim formatu.",
    cover_img: require("./assets/images/products/zyn-spearmint-slim-strong-front.webp"),
    keywords:
      "spearmint, osvežavajuće, nikotin, slim, snussrbija, online prodaja",
  },
  {
    id: 118,
    title: "Fresh Mint Slim",
    category: "ZYN",
    meta_description:
      "Fresh Mint Slim pruža blagu i osvežavajuću aromu sveže mente u slim formatu.",
    cover_img: require("./assets/images/products/zyn-fresh-mint-slim-front.webp"),
    keywords: "menta, osvežavajuće, nikotin, slim, snussrbija, online prodaja",
  },
  {
    id: 119,
    title: "White Blueberry",
    category: "CUBA",
    meta_description:
      "White Blueberry donosi bogat i osvežavajući ukus sočne borovnice, savršen za ljubitelje voćnih i aromatičnih iskustava.",
    cover_img: require("./assets/images/products/cuba-white-blueberry-front.webp"),
    keywords:
      "borovnica, voćno, osvežavajuće, nikotin, snussrbija, online prodaja",
  },
  {
    id: 120,
    title: "Arctic Freeze",
    category: "XQS",
    meta_description:
      "Arctic Freeze nudi osvežavajući doživljaj snažnog peperminta uz intenzivnu ledenu senzaciju, idealan za one koji traže pravo osveženje.",
    cover_img: require("./assets/images/products/xqs-arctic-freeze-front.webp"),
    keywords:
      "menta, hladno, osvežavajuće, nikotin, slim, snussrbija, online prodaja",
  },
  {
    id: 121,
    title: "Berrynana Twist",
    category: "XQS",
    meta_description:
      "Berrynana Twist kombinuje slatke note bobičastog voća sa egzotičnim dodirom banane, pružajući jedinstveno voćno osveženje.",
    cover_img: require("./assets/images/products/xqs-berrynana-twist-front.webp"),
    keywords: "bobice, banana, voćno, lagano, nikotin, slim, snussrbija",
  },
  {
    id: 122,
    title: "Strawberry Kiwi",
    category: "XQS",
    meta_description:
      "Strawberry Kiwi donosi eksploziju ukusa sa savršenom ravnotežom između slatke jagode i blago kiselkastog kivija.",
    cover_img: require("./assets/images/products/xqs-strawberry-kiwi-front.webp"),
    keywords: "jagoda, kivi, voćno, osvežavajuće, slim, nikotin, snussrbija",
  },
  {
    id: 123,
    title: "Chili Mango",
    category: "XQS",
    meta_description:
      "Chili Mango pruža neodoljiv spoj tropskog manga i uzbudljive ljutine čilija, savršeno za avanturiste.",
    cover_img: require("./assets/images/products/xqs-chili-mango-front.webp"),
    keywords: "mango, čili, ljuto, tropsko, voćno, slim, nikotin, snussrbija",
  },
  {
    id: 124,
    title: "Citrus Strong",
    category: "XQS",
    meta_description:
      "Citrus Strong donosi eksplozivnu citrusnu svežinu sa jačom dozom nikotina za energično iskustvo.",
    cover_img: require("./assets/images/products/xqs-citrus-strong-front.webp"),
    keywords: "citrus, limun, osvežavajuće, jako, slim, nikotin, snussrbija",
  },
  {
    id: 125,
    title: "Elderflower Light",
    category: "XQS",
    meta_description:
      "Elderflower Light nudi blag cvetni ukus zove u kombinaciji sa laganom dozom nikotina.",
    cover_img: require("./assets/images/products/xqs-elderflower-light-front.webp"),
    keywords: "zova, cvetno, lagano, slim, nikotin, snussrbija",
  },
  {
    id: 126,
    title: "Soft Toffee Light",
    category: "XQS",
    meta_description:
      "Soft Toffee Light donosi nežan i sladak ukus karamele uz niži sadržaj nikotina za opuštajuće uživanje.",
    cover_img: require("./assets/images/products/xqs-soft-toffee-light-front.webp"),
    keywords: "karamela, slatko, lagano, slim, nikotin, snussrbija",
  },
  {
    id: 127,
    title: "Fizzy Cola Light",
    category: "XQS",
    meta_description:
      "Fizzy Cola Light pruža šumeće iskustvo uz prepoznatljiv ukus kole, sa blagim nikotinom.",
    cover_img: require("./assets/images/products/xqs-fizzy-cola-light-front.webp"),
    keywords: "kola, šumeće, lagano, osvežavajuće, slim, nikotin, snussrbija",
  },
  {
    id: 128,
    title: "Black Cherry Slim Strong",
    category: "XQS",
    meta_description:
      "Black Cherry donosi pun i bogat ukus crne višnje u snažnom slim formatu za istinske ljubitelje voćnog osveženja.",
    cover_img: require("./assets/images/products/xqs-black-cherry-front.webp"),
    keywords: "višnja, crna višnja, voćno, jako, slim, nikotin, snussrbija",
  },
  {
    id: 129,
    title: "Cool Ice Mini 4mg",
    category: "XQS",
    meta_description:
      "Cool Ice Mini je idealan za diskretno i osvežavajuće iskustvo, sa blagim udarom nikotina.",
    cover_img: require("./assets/images/products/xqs-cool-ice-mini-front.webp"),
    keywords:
      "menta, mini, diskretno, osvežavajuće, lagano, nikotin, snussrbija",
  },
  {
    id: 130,
    title: "Cool Ice X-strong",
    category: "XQS",
    meta_description:
      "Cool Ice X-strong pruža intenzivan udar mente sa snažnim nikotinskim efektom, idealno za iskusne korisnike.",
    cover_img: require("./assets/images/products/xqs-cool-ice-xstrong-front.webp"),
    keywords: "menta, osvežavajuće, jako, slim, nikotin, snussrbija",
  },
  {
    id: 131,
    title: "Orange Apple Slim Strong",
    category: "XQS",
    meta_description:
      "Orange Apple Strong kombinuje citrusnu svežinu narandže sa voćnim notama jabuke za bogat ukus.",
    cover_img: require("./assets/images/products/xqs-orange-apple-front.webp"),
    keywords: "narandža, jabuka, voćno, jako, slim, nikotin, snussrbija",
  },
  {
    id: 132,
    title: "Hallonsoda Strong",
    category: "XQS",
    meta_description:
      "Hallonsoda Strong donosi gaziranu malinastu senzaciju u snažnoj dozi – slatko i osvežavajuće.",
    cover_img: require("./assets/images/products/xqs-hallonsoda-front.webp"),
    keywords: "malina, soda, voćno, šumeće, slim, nikotin, snussrbija",
  },
  {
    id: 133,
    title: "Blueberry Mint Strong",
    category: "XQS",
    meta_description:
      "Blueberry Mint Strong kombinuje ukus zrelih borovnica sa hladnim dodirom mente.",
    cover_img: require("./assets/images/products/xqs-blueberry-mint-front.webp"),
    keywords:
      "borovnica, menta, voćno, osvežavajuće, slim, nikotin, snussrbija",
  },
  {
    id: 134,
    title: "Tropical Light",
    category: "XQS",
    meta_description:
      "Tropical Light donosi osvežavajuću tropsku aromu u laganom formatu, idealan za svakodnevno opuštanje.",
    cover_img: require("./assets/images/products/xqs-tropical-light-front.webp"),
    keywords: "tropsko, voćno, lagano, slim, nikotin, snussrbija",
  },
  {
    id: 135,
    title: "Tropical Strong",
    category: "XQS",
    meta_description:
      "Tropical Strong kombinuje egzotične tropske ukuse sa snažnim nikotinskim efektom.",
    cover_img: require("./assets/images/products/xqs-tropical-strong-front.webp"),
    keywords: "tropsko, voćno, jako, slim, nikotin, snussrbija",
  },
  {
    id: 136,
    title: "Fizzy Cola Strong",
    category: "XQS",
    meta_description:
      "Fizzy Cola Strong pruža šumeći ukus kole sa dodatnim nikotinskim intenzitetom.",
    cover_img: require("./assets/images/products/xqs-fizzy-cola-strong-front.webp"),
    keywords: "kola, šumeće, jako, slim, osvežavajuće, nikotin, snussrbija",
  },
  {
    id: 137,
    title: "Blueberry Mint Light",
    category: "XQS",
    meta_description:
      "Blueberry Mint Light kombinuje nežnu borovnicu sa svežim dodirom mente.",
    cover_img: require("./assets/images/products/xqs-blueberry-mint-light-front.webp"),
    keywords:
      "borovnica, menta, lagano, slim, osvežavajuće, nikotin, snussrbija",
  },
  // CLEW 10 mg
  {
    id: 138,
    title: "Wintergreen 10mg",
    category: "CLEW",
    meta_description:
      "Wintergreen 10mg pruža osvežavajuću aromu zimske zelene mente uz 10 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-wintergreen-10mg_1_uQyOqzeYaMSqWSaDxClo8LPgTCUyceA2QC84PgsA.webp",
    keywords:
      "zimska zelena, metvica, 10mg, slim, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 139,
    title: "Blueberry 10mg",
    category: "CLEW",
    meta_description:
      "Blueberry 10mg kombinuje sočne note borovnice uz 10 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-blueberry-10mg_1_pjo1tqCxZyGGOQeP70DgnenQK9K9SqmotHr0Lvk7.webp",
    keywords:
      "borovnica, 10mg, slim, voćno, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 140,
    title: "Watermelon 10mg",
    category: "CLEW",
    meta_description:
      "Watermelon 10mg donosi sočni ukus lubenice i 10 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-watermelon-10mg_1_Bu6Ddgy085ms5r537a4U5xBcWo3mRRHqN4S2Y0An.webp",
    keywords:
      "lubenica, 10mg, slim, sočni, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 141,
    title: "Spearmint 10mg",
    category: "CLEW",
    meta_description:
      "Spearmint 10mg pruža svežu aromu metvice i 10 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-spearmint-10mg_1_g9LFreoQBiRYd33WbaJYl2Kiaq4X5G22RL8XSySV.webp",
    keywords:
      "spearmint, metvica, 10mg, slim, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 142,
    title: "Menthol 10mg",
    category: "CLEW",
    meta_description:
      "Menthol 10mg donosi intenzivan mentolni doživljaj sa 10 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-menthol-10mg_1_lrCO1XxedjlF2MnsnwPRAQTocfnHYkt1OYOKkl9B.webp",
    keywords:
      "mentol, 10mg, slim, hladno, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 143,
    title: "Cool Mint 10mg",
    category: "CLEW",
    meta_description:
      "Cool Mint 10mg kombinuje hladni miks mente sa 10 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-cool-mint-10mg_1_fl3F4GprXgqVmnZNmtPngHpnvqzi3R98umICN2Rf.webp",
    keywords:
      "cool mint, mint, 10mg, slim, hladno, osvežavajuće, nikotin, snussrbija, clew",
  },

  // CLEW 20 mg
  {
    id: 144,
    title: "Wintergreen 20mg",
    category: "CLEW",
    meta_description:
      "Wintergreen 20mg pruža intenzivniju aromu zimske zelene mente uz 20 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-wintergreen-20mg_1_HXV2auTxTcjHPRDFaXm9nNVtBfkhMY5qwfHIlU3Z.webp",
    keywords:
      "zimska zelena, metvica, 20mg, slim, jak, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 145,
    title: "Blueberry 20mg",
    category: "CLEW",
    meta_description:
      "Blueberry 20mg nudi pojačane borovnica note sa 20 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-blueberry-20mg_1_QyRHJ3xzb5nPIZOYNBAvxjbIG834ijJO8ZMUgqYu.webp",
    keywords:
      "borovnica, 20mg, slim, jak, voćno, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 146,
    title: "Watermelon 20mg",
    category: "CLEW",
    meta_description:
      "Watermelon 20mg donosi intenzivni sočni ukus lubenice i 20 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-watermelon-20mg_1_h6glJgVOkmL55mB3GPQEilRejU0R9TmJf4luNIGQ.webp",
    keywords:
      "lubenica, 20mg, slim, jak, sočni, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 147,
    title: "Spearmint 20mg",
    category: "CLEW",
    meta_description:
      "Spearmint 20mg kombinuje snažnu aromu metvice sa 20 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-spearmint-20mg_1_x6FlZK2wZp0fiXPUCCcwikqmiw4Q5yD3mTTaRTfF.webp",
    keywords:
      "spearmint, metvica, 20mg, slim, jak, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 148,
    title: "Menthol 20mg",
    category: "CLEW",
    meta_description:
      "Menthol 20mg pruža snažan mentolni efekat i 20 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-menthol-20mg_1_Phqj3tdtDB4FDfHfRTBgGKh2O2oOPGTvOveIgUgw.webp",
    keywords:
      "mentol, 20mg, slim, jak, hladno, osvežavajuće, nikotin, snussrbija, clew",
  },
  {
    id: 149,
    title: "Cool Mint 20mg",
    category: "CLEW",
    meta_description:
      "Cool Mint 20mg donosi ekstremno hladan miks mente sa 20 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/clew/clew-cool-mint-20mg_1_DMWXnj6oajnQMGRlDW8qJk3zpnqmZ3soa0NtWM6n.webp",
    keywords:
      "cool mint, mint, 20mg, slim, jak, hladno, osvežavajuće, nikotin, snussrbija, clew",
  },

  // STNG MAX
  {
    id: 150,
    title: "Cola Cherry MAX",
    category: "STNG",
    meta_description:
      "Cola Cherry MAX pruža intenzivan spoj kole i trešnje sa 27,5 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/stng/stng-cola-cherry-max-en_1_eeO8R3gt2d6u6gyKcP8oYkj9OAcs9ZoBRInVdiwB.webp",
    keywords:
      "cola, trešnja, 27,5mg, slim, jak, osvežavajuće, nikotin, snussrbija, stng",
  },
  {
    id: 151,
    title: "Berry Seltzer MAX",
    category: "STNG",
    meta_description:
      "Berry Seltzer MAX kombinuje gazirane bobice sa 27,5 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/stng/stng-berry-seltzer-max-en_1_K9svOybX2TZfd82NlMRDbC6RJua3nNsODe7fp5wv.webp",
    keywords:
      "bobičasto voće, seltzer, 27,5mg, slim, jak, osvežavajuće, nikotin, snussrbija, stng",
  },
  {
    id: 152,
    title: "Bubble MAX",
    category: "STNG",
    meta_description:
      "Bubble MAX donosi sladak mehurić ukusa bubble gum-a uz 27,5 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/stng/stng-bubble-max-en_1_9xdaU1xlxgdWCzT2Tk3ExfyYm7E4FuLhNSuthPsI.webp",
    keywords:
      "bubble gum, 27,5mg, slim, sladak, jak, osvežavajuće, nikotin, snussrbija, stng",
  },

  // CUBA Ninja (2x)
  {
    id: 153,
    title: "Ninja Orange Strong",
    category: "CUBA",
    meta_description:
      "Ninja Orange Strong kombinuje intenzivnu aromu sočne narandže sa 15.6 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/cuba/cuba-ninja-orange-strong_1_ePhkrsjsAyVVZayIcPAzMVpvDTdiq3v1LK1oNjlq.jpg",
    keywords:
      "narandža, citrus, 15.6mg, slim, jak, osvežavajuće, nikotin, snussrbija, cuba",
  },
  {
    id: 154,
    title: "Ninja Strawberry Strong",
    category: "CUBA",
    meta_description:
      "Ninja Strawberry Strong nudi bogat ukus jagode sa 15.6 mg nikotina po kesici.",
    cover_img:
      "./assets/images/products/cuba/cuba-ninja-strawberry-strong_1_93wpSkS6NCADwtBiWHqH2nRwK7aWIOciEDbI4BGb.jpg",
    keywords:
      "jagoda, berry, 15.6mg, slim, sladak, osvežavajuće, nikotin, snussrbija, cuba",
  },
  {
    id: 155,
    title: "Ice Cool Hard Double Mint",
    category: "FEDRS",
    meta_description:
      "Ice Cool Hard Double Mint pruža snažan mentol udar sa 65 mg nikotina po gramu.",
    cover_img: "./assets/images/products/fedrs-ice-cool-hard-double-mint_1.jpg",
    keywords:
      "mint, dvostruki mentol, 65mg, slim, osvežavajuće, nikotin, snussrbija, fedrs",
  },
  {
    id: 156,
    title: "McLaren Sweet Papaya",
    category: "VELO",
    meta_description:
      "Velo McLaren Sweet Papaya donosi voćnu egzotiku sa 11.4 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/velo/velo-mclaren-sweet-papaya_1_UeSNI5oB3j2vDSUAxIkBqHH7wbKDrsBQ15VGt8tu.webp",
    keywords: "papaja, voćno, 11mg, slim, egzotično, nikotin, snussrbija, velo",
  },
  {
    id: 157,
    title: "Ice Cool",
    category: "RUSH",
    meta_description:
      "RUSH Ice Cool donosi snažan mint efekat sa 16 mg nikotina po gramu i 11.2 mg po kesici.",
    cover_img:
      "./assets/images/products/rush/rush-ice-cool_1_Td2USYdnoLKYH3q0HWe36TOEw4EHDYfeAUR9S5x9.webp",
    keywords:
      "mint, mentol, 16mg, slim, osvežavajuće, nikotin, snussrbija, rush",
  },
  {
    id: 158,
    title: "Green Mint",
    category: "RUSH",
    meta_description:
      "RUSH Green Mint kombinuje prirodan ukus mente sa visokom koncentracijom nikotina (16 mg/g, 11.2 mg po kesici).",
    cover_img:
      "./assets/images/products/rush/rush-green-mint_1_dA2dHCGBXzvKCVt1SM8zBck87Rrpe4r1Hgsx6ndG.webp",
    keywords:
      "mint, zelena menta, 16mg, slim, osvežavajuće, nikotin, snussrbija, rush",
  },
  {
    id: 159,
    title: "Arctic Freeze",
    category: "XQS",
    meta_description:
      "XQS Arctic Freeze pruža intenzivan osećaj hlađenja uz 11 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/xqs/xqs-arctic-freeze-ultra_1_Ikt7uZZxKY5ypCi3NHZ8vvwl98f41R4lEvaoK52t.webp",
    keywords:
      "peppermint, mentol, 11mg, slim, ledeno, nikotin, snussrbija, xqs",
  },
  {
    id: 160,
    title: "Boost Mint Extreme",
    category: "RUSH",
    meta_description:
      "RUSH Boost Mint Extreme pruža snažan, osvežavajući mentol efekat uz 30 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/rush/rush-boost-mint-extreme_1_DebT1C23XqJiKFK10RuoueQPu2M3DWLhgL8s4eBb.webp",
    keywords: "mint, mentol, 30mg, slim, extreme, nikotin, snussrbija, rush",
  },
  {
    id: 161,
    title: "Black Forest Berries",
    category: "CUBA",
    meta_description:
      "CUBA Black Forest Berries donosi intenzivan ukus tamnog šumskog voća uz snažnih 43 mg nikotina po gramu, namenjeno iskusnim korisnicima.",
    cover_img:
      "./assets/images/products/cuba/cuba-black-forest-berries-front.webp",
    keywords:
      "forest berries, black, 43mg, slim, strong, nikotin, snussrbija, cuba",
  },
  {
    id: 162,
    title: "Gold Edition Blue Raspberry",
    category: "PABLO",
    meta_description:
      "PABLO Gold Edition Blue Raspberry donosi intenzivan i sladak ukus plave maline uz ekstremnih 50 mg nikotina po gramu, namenjeno isključivo iskusnim korisnicima.",
    cover_img:
      "./assets/images/products/pablo/pablo-gold-blue-raspberry-front.webp",
    keywords:
      "blue raspberry, gold edition, 50mg, slim, extra strong, nikotin, snussrbija, pablo",
  },
  {
    id: 163,
    title: "Gold Edition Frosted Mint",
    category: "PABLO",
    meta_description:
      "PABLO Gold Edition Frosted Mint pruža ekstremno jak i ledeno hladan ukus mente uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-gold-frosted-mint-front.webp",
    keywords:
      "frosted mint, mint, gold edition, 50mg, slim, extra strong, pablo",
  },
  {
    id: 164,
    title: "Gold Edition Dark Cherry",
    category: "PABLO",
    meta_description:
      "PABLO Gold Edition Dark Cherry donosi bogat i intenzivan ukus tamne trešnje uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-gold-dark-cherry-front.webp",
    keywords:
      "dark cherry, cherry, gold edition, 50mg, slim, extra strong, pablo",
  },
  {
    id: 165,
    title: "Gold Edition Kiwi",
    category: "PABLO",
    meta_description:
      "PABLO Gold Edition Kiwi donosi egzotičan i osvežavajući ukus kivija uz 50 mg nikotina po gramu.",
    cover_img: "./assets/images/products/pablo/pablo-gold-kiwi-front.webp",
    keywords: "kiwi, gold edition, 50mg, slim, extra strong, pablo",
  },
  {
    id: 166,
    title: "Gold Edition Passion Fruit",
    category: "PABLO",
    meta_description:
      "PABLO Gold Edition Passion Fruit donosi intenzivan tropski ukus marakuje uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-gold-passion-fruit-front.webp",
    keywords: "passion fruit, tropical, gold edition, 50mg, slim, pablo",
  },
  {
    id: 167,
    title: "Gold Edition Tropical Punch",
    category: "PABLO",
    meta_description:
      "PABLO Gold Edition Tropical Punch donosi snažan mix tropskog voća uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-gold-tropical-punch-front.webp",
    keywords: "tropical punch, fruit mix, gold edition, 50mg, slim, pablo",
  },
  {
    id: 168,
    title: "Gold Edition White Mint",
    category: "PABLO",
    meta_description:
      "PABLO Gold Edition White Mint donosi čist i leden ukus mente uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-gold-white-mint-front.webp",
    keywords: "white mint, mint, gold edition, 50mg, slim, pablo",
  },
  {
    id: 169,
    title: "Exclusive Cola",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Cola donosi autentičan ukus kole uz 50 mg nikotina po gramu.",
    cover_img: "./assets/images/products/pablo/pablo-exclusive-cola-front.webp",
    keywords: "cola, exclusive, 50mg, slim, pablo",
  },
  {
    id: 170,
    title: "Exclusive Green Mint",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Green Mint donosi snažan i osvežavajući ukus zelene mente uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-green-mint-front.webp",
    keywords: "green mint, mint, exclusive, 50mg, pablo",
  },
  {
    id: 171,
    title: "Exclusive Lemonade",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Lemonade donosi osvežavajući citrusni ukus limunade uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-lemonade-front.webp",
    keywords: "lemonade, citrus, exclusive, 50mg, pablo",
  },
  {
    id: 172,
    title: "Exclusive Orange",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Orange donosi snažan citrusni ukus narandže uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-orange-front.webp",
    keywords: "orange, citrus, exclusive, 50mg, pablo",
  },
  {
    id: 173,
    title: "Exclusive Pineapple",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Pineapple donosi egzotičan tropski ukus ananasa uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-pineapple-front.webp",
    keywords: "pineapple, tropical, exclusive, 50mg, pablo",
  },
  {
    id: 174,
    title: "Exclusive Dark Cherry",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Dark Cherry donosi bogat voćni ukus tamne trešnje uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-dark-cherry-front.webp",
    keywords: "dark cherry, fruit, exclusive, 50mg, pablo",
  },
  {
    id: 175,
    title: "Exclusive Pink Lemonade",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Pink Lemonade donosi osvežavajući citrusno-voćni ukus uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-pink-lemonade-front.webp",
    keywords: "pink lemonade, citrus, exclusive, 50mg, pablo",
  },
  {
    id: 176,
    title: "Frosty Mint Extreme",
    category: "ICEBERG",
    meta_description:
      "Iceberg Frosty Mint Extreme donosi pojačan ledeni ukus mente uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/iceberg/iceberg-frosty-mint-extreme-front.webp",
    keywords:
      "frosty mint extreme, mint, ice mint, extreme, 50mg, slim, iceberg",
  },

  {
    id: 177,
    title: "Sour Berries Extreme",
    category: "ICEBERG",
    meta_description:
      "Iceberg Sour Berries Extreme donosi intenzivan kiselkasti miks bobica uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/iceberg/iceberg-sour-berries-extreme-front.webp",
    keywords:
      "sour berries extreme, berries, fruit, extreme, 50mg, slim, iceberg",
  },

  {
    id: 179,
    title: "Cherry Extreme",
    category: "ICEBERG",
    meta_description:
      "Iceberg Cherry Extreme donosi intenzivan i pun ukus trešnje uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/iceberg/iceberg-cherry-extreme-front.webp",
    keywords: "cherry extreme, cherry, fruit, extreme, 50mg, slim, iceberg",
  },

  {
    id: 180,
    title: "Guava Lime Extreme",
    category: "ICEBERG",
    meta_description:
      "Iceberg Guava Lime Extreme donosi intenzivan spoj tropske guave i osvežavajuće limete uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/iceberg/iceberg-guava-lime-extreme-front.webp",
    keywords:
      "guava lime extreme, guava, lime, tropical, extreme, 50mg, slim, iceberg",
  },
  {
    id: 181,
    title: "Exclusive Cola Cherry",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Cola Cherry donosi spoj klasičnog ukusa kole i voćne note trešnje uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-cola-cherry-front.webp",
    keywords: "cola cherry, cola, cherry, exclusive, 50mg, slim, pablo",
  },

  {
    id: 182,
    title: "Exclusive Strawberry Cheesecake",
    category: "PABLO",
    meta_description:
      "PABLO Exclusive Strawberry Cheesecake donosi bogat ukus jagode sa kremastim cheesecake tonom uz 50 mg nikotina po gramu.",
    cover_img:
      "./assets/images/products/pablo/pablo-exclusive-strawberry-cheesecake-front.webp",
    keywords:
      "strawberry cheesecake, strawberry, dessert, exclusive, 50mg, slim, pablo",
  },

  {
    id: 183,
    title: "Dark Blackcurrant",
    category: "VELO",
    meta_description:
      "VELO Dark Blackcurrant donosi bogat i intenzivan ukus crne ribizle sa izraženim voćnim karakterom.",
    cover_img:
      "./assets/images/products/velo/velo-dark-blackcurrant-front.webp",
    keywords: "dark blackcurrant, blackcurrant, berry, velo, slim",
  },
  {
    id: 184,
    title: "Black Grape",
    category: "CUBA",
    meta_description:
      "CUBA Black Grape donosi bogat i sočan ukus tamnog grožđa u kombinaciji sa vrlo snažnih 43 mg nikotina.",
    cover_img: "./assets/images/products/cuba/cuba-black-grape-front.webp",
    keywords: "black grape, grape, cuba, cuba black, slim, grozdje",
  },
  {
    id: 185,
    title: "Black Tropical Fruit",
    category: "CUBA",
    meta_description:
      "CUBA Black Tropical Fruit donosi osvežavajući miks egzotičnog tropskog voća sa 43 mg nikotina.",
    cover_img:
      "./assets/images/products/cuba/cuba-black-tropical-fruit-front.webp",
    keywords:
      "black tropical fruit, tropical, fruit, cuba, cuba black, slim, tropsko voce",
  },
  {
    id: 186,
    title: "Black Raspberry",
    category: "CUBA",
    meta_description:
      "CUBA Black Raspberry donosi bogat i sočan ukus zrele maline u kombinaciji sa 43 mg nikotina.",
    cover_img: "./assets/images/products/cuba/cuba-black-raspberry-front.webp",
    keywords: "black raspberry, raspberry, cuba, cuba black, slim, malina",
  },
  {
    id: 187,
    title: "Black Mango",
    category: "CUBA",
    meta_description:
      "CUBA Black Mango donosi intenzivan i sočan ukus zrelog manga u kombinaciji sa vrlo snažnih 43 mg nikotina.",
    cover_img: "./assets/images/products/cuba/cuba-black-mango-front.webp",
    keywords: "black mango, mango, cuba, cuba black, slim, egzoticno",
  },
];

export const home_slider = [
  {
    id: 1,
    bg: "#b2dfda",
    img: require("./assets/images/pocetna_12.webp"),
    title: "Ponuda",
    desc: "U našoj ponudi možete pronaći veliki izbor Snusa najpoznatijih brendova na tržištu. Odaberite između različitih ukusa, intenziteta nikotina i vrsta pakovanja.",
    textColor: "#025E4F",
    titleEN: "Offer",
    descEN:
      "In our offer, you can find a wide selection of Snus from the most well-known brands on the market. Choose from different flavors, nicotine strengths, and packaging types.",
  },
  {
    id: 2,
    bg: "#bfc2c8",
    img: require("./assets/images/home1.webp"),
    title: "Izbor",
    desc: "Kod nas možete pronaći najbolji izbor Snusa po najpovoljnijim cenama na tržištu. Odaberite između najpoznatijih svetskih brendova i uživajte u savršenom spoju ukusa i kvaliteta.",
    textColor: "#cb0d29",
    titleEN: "Choice",
    descEN:
      "With us, you can find the best selection of Snus at the most affordable prices on the market. Choose from the most famous international brands and enjoy the perfect combination of taste and quality.",
  },
  {
    id: 3,
    //bg: `linear-gradient(to bottom, #cb0d29 0%, #cb0d29 60.7%, hsl(0deg,0%,96%) 60.7%)`,//"#cb0d29, //60%
    bg: "#f5841f",
    img: require("./assets/images/pocetna_11.webp"),
    title: "Preporuka",
    desc: "Naš tim stručnjaka za snus će Vam pomoći u odabiru najboljeg brenda i ukusa za Vas i Vaše želje.",
    textColor: "black",
    titleEN: "Suggestion",
    descEN:
      "Our team of snus experts will help you choose the best one for your taste and preferences.",
  },
];

export const discountOptions = [
  {
    id: 1,
    quantity: 4,
    maxQuantity: 49,
    backgroundColor: "#008080",
    message: "Besplatna dostava",
    messageEN: "Free Delivery",
  },
  // {
  //   id: 2,
  //   quantity: 4,
  //   backgroundColor: "#00AEAE",
  //   message: "Extra -6.5%",
  //   messageEN: "Extra -6.5%",
  // },
  {
    id: 3,
    quantity: 9,
    backgroundColor: "#008080",
    message: "Extra -10%",
    messageEN: "Extra -10%",
  },
  // {
  //   id: 4,
  //   quantity: 29,
  //   backgroundColor: "#00AEAE",
  //   message: "do -30% ",
  //   messageEN: "Up to -30%",
  // },
  {
    id: 5,
    quantity: 49,
    backgroundColor: "#008080",
    message: "Veliki -22%",
    messageEN: "Large -22%",
  },
];

const data = [
  {
    id: 1,
    image:
      "https://a.storyblok.com/f/153226/1920x1080/b9fe274750/three-penguin-chairs.webp",
    title: "Televizori",
    text: "Otkrijte najnovije modele televizora",
    link: "/shop/1",
    background: "#121212",
  },
  {
    id: 2,
    image:
      "https://a.storyblok.com/f/153226/1920x1080/452da1483f/menu_elizabeth_lounge_chair_elizabeth_ottoman-extended-1920x1080.webp",
    title: "Telefoni",
    text: "Odaberite savršen telefon za sebe",
    link: "/shop/3",
    background: "#140005",
  },
  {
    id: 3,
    image:
      "https://a.storyblok.com/f/153226/1920x1080/0b0f06a2cf/pagode-1920x1080.webp",
    title: "Kamere",
    text: "Napravite najbolje fotografije uz našu selekciju kamera",
    link: "/shop/4",
    background: "#464033",
  },
  {
    id: 4,
    image:
      "https://a.storyblok.com/f/153226/1920x1080/0b0f06a2cf/pagode-1920x1080.webp",
    title: "Laptopovi",
    text: "Radite i zabavljajte se uz najnovije modele laptopova.",
    link: "/shop/2",
    background: "#7E7C73",
  },
];
export default data;
